
(() => {
const ICONS={
home:'<path d="m3 11 9-8 9 8v10h-6v-6H9v6H3V11Z"/>',
accessories:'<path d="M5 4h14v6H5V4Zm0 10h14v6H5v-6ZM8 7h.01M8 17h.01"/>',
habits:'<path d="m12 2 1.6 5.2L19 9l-5.4 1.8L12 16l-1.6-5.2L5 9l5.4-1.8L12 2Zm7 12 .9 2.7L23 18l-3.1 1.3L19 22l-.9-2.7L15 18l3.1-1.3L19 14Z"/>',
chart:'<path d="M5 20V9m5 11V4m5 16v-7m4 7V7"/>',
plus:'<path d="M12 5v14M5 12h14"/>',
minus:'<path d="M5 12h14"/>',
search:'<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/>',
light:'<path d="M9 21h6m-3-3v3m-5-8a5 5 0 1 1 10 0c0 2-1 3-2 4H9c-1-1-2-2-2-4Z"/>',
shutter:'<path d="M5 4h14v16H5V4Zm3 4h8M8 12h8M8 16h8"/>',
outlet:'<path d="M8 3v6m8-6v6M6 9h12v2a6 6 0 0 1-12 0V9Zm6 8v4"/>',
switch:'<path d="M7 8h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8Zm0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>',
power:'<path d="M12 2v10m-5.7-7.7a8 8 0 1 0 11.4 0"/>',
up:'<path d="m7 14 5-5 5 5"/>',
down:'<path d="m7 10 5 5 5-5"/>',
stop:'<path d="M8 8h8v8H8V8Z"/>',
play:'<path d="m8 5 11 7-11 7V5Z"/>',
pause:'<path d="M8 5h3v14H8V5Zm5 0h3v14h-3V5Z"/>',
editGrid:'<path d="M4 4h6v6H4V4Zm10 0h6v6h-6V4ZM4 14h6v6H4v-6Zm10 0h3m-3 4h6m-3-3v6"/>',
close:'<path d="M5 5 19 19M19 5 5 19"/>',
settings:'<path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-5 1 3 3 1 3-1 2 3-2 2 .3 3 2.7 2-2 3-3-.5-2 2.5H10l-2-2.5-3 .5-2-3 2.7-2L6 11 4 9l2-3 3 1 3-1 1-3Z"/>',
back:'<path d="m15 5-7 7 7 7"/>',
chevron:'<path d="m9 5 7 7-7 7"/>',
expandMore:'<path d="m7 10 5 5 5-5"/>',
menuCircle:'<circle cx="12" cy="12" r="9"/><circle cx="8.5" cy="12" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="15.5" cy="12" r="1.2"/>',
clock:'<circle cx="12" cy="12" r="9"/><path d="M12 7v6l4 2"/>',
calendar:'<path d="M7 3v3m10-3v3M4 8h16v12H4V8Zm4 4h3m2 0h3"/>',
sunset:'<path d="M4 18h16M6 14h12m-9-3a3 3 0 0 1 6 0M12 2v3M4.9 5.9 7 8M19.1 5.9 17 8"/>',
moon:'<path d="M20 15.2A8 8 0 1 1 8.8 4 6.5 6.5 0 0 0 20 15.2Z"/><path d="m17 4 .6 1.7L19 6.3l-1.4.6L17 8.5l-.6-1.6L15 6.3l1.4-.6L17 4Z"/>',
battery:'<path d="M8 3h8v3h2v15H6V6h2V3Zm4 5-3 6h3l-1 4 4-7h-3l1-3Z"/>',
puzzle:'<path d="M8 3h5v4a2 2 0 1 0 4 0V3h4v5h-3a2 2 0 1 0 0 4h3v5h-5a2 2 0 1 1-4 0H8v-4a2 2 0 1 0-4 0v4H3v-5h4a2 2 0 1 0 0-4H3V3h5Z"/>',
module:'<path d="M7 7h10v10H7V7Zm-3 3h3m10 0h3M4 14h3m10 0h3M10 4v3m4-3v3m-4 10v3m4-3v3"/>',
nfc:'<path d="M5 6v12m4-14v16m4-13v10m4-7v4m3-2v0"/>',
sparkles:'<path d="m12 2 1.7 5.3L19 9l-5.3 1.7L12 16l-1.7-5.3L5 9l5.3-1.7L12 2Zm7 12 .8 2.5L22 18l-2.2 1.5L19 22l-.8-2.5L16 18l2.2-1.5L19 14Z"/>',
notification:'<path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Zm-8 12h4"/>',
wait:'<path d="M7 3h10M7 21h10M8 3c0 5 8 5 8 9s-8 4-8 9m8-18c0 5-8 5-8 9s8 4 8 9"/>',
room:'<path d="M4 12 12 5l8 7v8H4v-8Zm5 8v-5h6v5"/>',
members:'<path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm7 1a3 3 0 1 0 0-6m-7 8a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7Z"/>',
rename:'<path d="m4 20 4-1 10-10-3-3L5 16l-1 4Z"/>',
trash:'<path d="M4 7h16M9 7V4h6v3m-8 0 1 14h8l1-14"/>',
qr:'<path d="M4 4h6v6H4V4Zm10 0h6v6h-6V4ZM4 14h6v6H4v-6Zm10 0h2m2 0h2m-6 4h6m-4-2v4"/>',
wifi:'<path d="M2 8a16 16 0 0 1 20 0M5 12a11 11 0 0 1 14 0m-10 4a5 5 0 0 1 6 0m-3 4h.01"/>',
check:'<path d="m4 12 5 5L20 6"/>',
copy:'<path d="M8 8h11v12H8V8Zm-3 8H4V4h11v1"/>',
info:'<path d="M12 17v-6m0-4h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z"/>'
};
const I=n=>`<svg viewBox="0 0 24 24" aria-hidden="true">${ICONS[n]||ICONS.settings}</svg>`;
const F=n=>`<span class="material-symbols-outlined fp-symbol-filled" aria-hidden="true">${n}</span>`;
const navIcon=(icon,label)=>{
 if(icon==='home'){
  return `<span class="material-symbols-outlined fp-nav-symbol" aria-hidden="true">home</span>`;
 }
 if(icon==='accessories'){
  return `<span class="material-symbols-outlined fp-nav-symbol" aria-hidden="true">dns</span>`;
 }
 if(icon==='chart'){
  return `<span class="material-symbols-outlined fp-nav-symbol" aria-hidden="true">equalizer</span>`;
 }
 if(icon==='habits'){
  return `<span class="material-symbols-outlined fp-nav-symbol" aria-hidden="true">auto_awesome</span>`;
 }
 return I(icon);
};
const habitIcon=()=>`<span class="material-symbols-outlined fp-entity-symbol" aria-hidden="true">auto_awesome</span>`;
const tvSparkline=()=>`<svg viewBox="0 0 280 120" preserveAspectRatio="none" aria-hidden="true">
 <path class="fp-tv-fill" d="M0 84 L30 34 L64 58 L92 24 L124 66 L148 74 L176 30 L208 104 L244 76 L280 88 V120 H0 Z"/>
 <path class="fp-tv-line" d="M0 84 L30 34 L64 58 L92 24 L124 66 L148 74 L176 30 L208 104 L244 76 L280 88"/>
</svg>`;
const tvAxis=()=>`<div class="fp-tv-axis" aria-hidden="true"><span>6</span><span>12</span><span>18</span></div>`;
const appbarIcon=name=>{
 if(name==='menuCircle'){
  return `<span class="material-symbols-outlined fp-appbar-symbol" aria-hidden="true">more_horiz</span>`;
 }
 return I(name);
};
const entityIcon=type=>{
 if(type==='light'){
  return `<span class="material-symbols-outlined fp-entity-symbol" aria-hidden="true">lightbulb</span>`;
 }
 if(type==='shutter'){
  return `<span class="material-symbols-outlined fp-entity-symbol" aria-hidden="true">roller_shades</span>`;
 }
 if(type==='outlet'){
  return `<span class="material-symbols-outlined fp-entity-symbol" aria-hidden="true">power</span>`;
 }
 return I(type);
};
const summaryIcon=type=>{
 if(type==='light')return `<span class="material-symbols-outlined fp-summary-symbol light" aria-hidden="true">lightbulb</span>`;
 if(type==='shutter')return `<span class="material-symbols-outlined fp-summary-symbol shutter" aria-hidden="true">roller_shades</span>`;
 if(type==='outlet')return `<span class="material-symbols-outlined fp-summary-symbol outlet" aria-hidden="true">power</span>`;
 return entityIcon(type);
};
const optionListIcon=icon=>{
 const map={
  puzzle:'lightbulb',
  shutter:'roller_shades',
  notification:'notifications',
  wait:'back_hand',
  habits:'auto_awesome',
  battery:'bolt',
  moon:'dark_mode',
  module:'dns',
  clock:'schedule',
  sunset:'wb_twilight',
  nfc:'nfc'
 };
 if(map[icon])return `<span class="material-symbols-outlined fp-option-symbol" aria-hidden="true">${map[icon]}</span>`;
 return I(icon);
};
const E=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
const clone=o=>JSON.parse(JSON.stringify(o));
const uid=p=>`${p}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,6)}`;

const INITIAL={
 tab:'home',
 plusOpen:false,
 editing:false,
 accessoryFilter:'all',
 accessoryRoom:'all',
 accessoryType:'all',
 accessoryDropdown:'',
 consumptionDropdown:'',
 formDropdown:'',
 formValues:{},
 accessoryQuery:'',
 period:'month',
 category:'all',
 dateOffset:0,
 home:{name:'MyHome',position:'Italia'},
 homeChoices:['MyHome','Casa Vacanze'],
 profile:{name:'Alessandro',subtitle:'Il mio profilo'},
 rooms:[
  {id:'living',name:'Soggiorno',icon:'room'},
  {id:'kitchen',name:'Cucina',icon:'room'},
  {id:'bedroom',name:'Camera',icon:'room'},
  {id:'outside',name:'Esterno',icon:'room'}
 ],
 devices:{
  luceSoggiorno:{id:'luceSoggiorno',name:'Luce soggiorno',room:'Soggiorno',type:'light',on:true,watt:12,energy:1.42,module:'LB0602-E'},
  luceCucina:{id:'luceCucina',name:'Luce cucina',room:'Cucina',type:'light',on:false,watt:9,energy:.86,module:'LB0801-E'},
  luceCamera:{id:'luceCamera',name:'Luce camera',room:'Camera',type:'light',on:false,watt:7,energy:.54,module:'LB0801-E'},
  tapparellaSoggiorno:{id:'tapparellaSoggiorno',name:'Tapparella soggiorno',room:'Soggiorno',type:'shutter',position:68,moving:false,energy:.31,module:'WC0601-E'},
  tapparellaCamera:{id:'tapparellaCamera',name:'Tapparella camera',room:'Camera',type:'shutter',position:100,moving:false,energy:.24,module:'WC0601-E'},
  presaTV:{id:'presaTV',name:'Presa TV',room:'Soggiorno',type:'outlet',on:true,watt:48,energy:2.36,module:'OL0801-E'},
  cancello:{id:'cancello',name:'Cancello',room:'Esterno',type:'switch',on:false,watt:0,energy:0,module:'SW0901-E'},
  luceEsterna:{id:'luceEsterna',name:'Luce esterna',room:'Esterno',type:'light',on:false,watt:11,energy:.47,module:'LB0801-E'}
 },
 modules:[
  {id:'m1',name:'Modulo luci zona giorno',model:'LB0602-E',serial:'70001001'},
  {id:'m2',name:'Modulo tapparella soggiorno',model:'WC0601-E',serial:'70001002'},
  {id:'m3',name:'Modulo tapparella camera',model:'WC0601-E',serial:'70001003'},
  {id:'m4',name:'Modulo presa TV',model:'OL0801-E',serial:'70001004'},
  {id:'m5',name:'Modulo cancello',model:'SW0901-E',serial:'70001005'}
 ],
 dashboard:[
  {id:'d1',kind:'device',ref:'luceSoggiorno'},
  {id:'d2',kind:'device',ref:'luceCucina'},
  {id:'d3',kind:'device',ref:'tapparellaSoggiorno'},
  {id:'d5',kind:'device',ref:'presaTV'},
  {id:'d7',kind:'habit',ref:'habitExit'}
 ],
 habits:[
  {
   id:'habitExit',name:'Esco di casa',active:false,disabled:false,
   summary:'Avvio manuale · 6 eventi',
   when:[{kind:'manual',icon:'play',title:'Avvio manuale',detail:'Dalla Dashboard'}],
   onlyIf:[],
   actions:[
    {kind:'action-accessory',deviceId:'luceSoggiorno',state:'Spegni'},
    {kind:'action-accessory',deviceId:'luceCucina',state:'Spegni'},
    {kind:'action-accessory',deviceId:'luceCamera',state:'Spegni'},
    {kind:'action-accessory',deviceId:'luceEsterna',state:'Spegni'},
    {kind:'action-accessory',deviceId:'presaTV',state:'Spegni'},
    {kind:'action-shutter',deviceId:'tapparellaSoggiorno',position:0}
   ]
  },
  {
   id:'habitNight',name:'Buonanotte',active:false,disabled:false,
   summary:'Avvio manuale · 5 eventi',
   when:[{kind:'manual',icon:'play',title:'Avvio manuale',detail:'Dalla sezione Abitudini'}],
   onlyIf:[],
   actions:[
    {kind:'action-accessory',deviceId:'luceSoggiorno',state:'Spegni'},
    {kind:'action-accessory',deviceId:'luceCucina',state:'Spegni'},
    {kind:'action-accessory',deviceId:'luceCamera',state:'Spegni'},
    {kind:'action-shutter',deviceId:'tapparellaSoggiorno',position:0},
    {kind:'action-shutter',deviceId:'tapparellaCamera',position:0}
   ]
  }
 ],
 schedules:{},
 sunRules:{},
 draftHabit:{name:'',when:[],onlyIf:[],actions:[]},
 pairing:{step:0,name:'Luce ingresso',room:'Soggiorno',input:'Interruttore'},
 selectedDashboardItems:[]
};

const DEMO_COPY={
 it:{
  timeLocale:'it-IT',
  ui:{
   liveDemo:'Live Demo',
   mobileCtaLabel:"Prova in anteprima l'App",
   hintTitle:'Interagisci con la demo',
   hintText:'Tocca il telefono per esplorare schermate e controlli.',
   defaultHeading:'Prova Freedompro Home',
   defaultSubheading:'Controlla la casa, prova le Abitudini e scopri i consumi con la stessa logica di navigazione dell’app.',
   appStoreAria:"Scarica dall'App Store",
   appStoreAlt:'Scarica su App Store',
   playStoreAria:'Disponibile su Google Play',
   playStoreAlt:'Disponibile su Google Play',
   nav:{home:'Casa',accessories:'Accessori',habits:'Abitudini',consumption:'Consumi'},
   states:{
    active:'Attiva',
    inactive:'Non attiva',
    on:'Acceso',
    off:'Spento',
    open:'Aperta',
    closed:'Chiusa'
   },
   home:{
    dashboard:'Dashboard',
    personalize:'Personalizza'
   },
   summary:{
    light:['Spente','1 Accesa','Accese'],
    shutter:['Chiuse','1 Aperta','Aperte'],
    outlet:['Spente','1 Accesa','Accese']
   },
   accessories:{
    searchPlaceholder:'Cerca',
    rooms:'Stanze',
    type:'Tipologia',
    roomAll:'Tutti',
    typeAll:'Tutti',
    types:{light:'Luci',shutter:'Tapparelle',outlet:'Prese',switch:'Contatti'},
    emptyTitle:'Nessun accessorio trovato',
    emptyText:'Prova con un nome, una stanza o un modulo diverso.'
   },
   habits:{
    emptyTitle:'Un nuovo comfort con le Abitudini',
    emptyText:'Imposta regole e azioni per rendere la tua casa ancora più confortevole.',
    promoTitle:'Scopri la potenza delle Abitudini',
    promoText:'Crea automazioni smart per luci, tapparelle, prese e molto altro.'
   },
   consumption:{
    segments:{day:'Giorno',week:'Settimana',month:'Mese',year:'Anno'},
    periods:{day:'Oggi',week:'Questa settimana',month:'giugno 2026',year:'2026'},
    totalPrefix:'Totale:',
    category:'Tipologia',
    categoryAll:'Tutti',
    categories:{light:'Luci',shutter:'Tapparelle',outlet:'Prese'}
   },
   common:{
    cancel:'Annulla',
    confirm:'Conferma',
    save:'Salva',
    done:'Fatto',
    add:'Aggiungi',
    create:'Crea',
    continue:'Continua',
    next:'Avanti',
    ok:'Ok',
    delete:'Elimina',
    rename:'Rinomina',
    module:'Modulo',
    room:'Stanza',
    accessory:'Accessorio',
    schedule:'Programma',
    sunriseSunset:'Alba e tramonto',
    configure:'Configura',
    unavailable:'Schermata non disponibile'
   },
   toasts:{
    officialApp:"Scopri tutto il potenziale di Freedompro con l'App ufficiale",
    currentPeriod:'Sei già nel periodo corrente',
    itemsAdded:'Elementi aggiunti alla Dashboard',
    copiedLink:'Link copiato',
    homeRenamed:'Casa rinominata',
    simulatedAction:'Operazione simulata',
    moduleRenamed:'Modulo rinominato',
    moduleRemoved:'Modulo rimosso',
    accessoryRenamed:'Accessorio rinominato',
    scheduleDeleted:'Programmazione eliminata',
    sunRuleDeleted:'Regola eliminata',
    demoReset:'Demo ripristinata',
    habitSaved:'Abitudine salvata',
    habitDisabled:'Abitudine non attiva',
    habitExecuted:'eseguita',
    roomAdded:'Stanza aggiunta',
    roomUpdated:'Stanza aggiornata',
    roomDeleted:'Stanza eliminata',
    accessoryAdded:'Accessorio aggiunto',
    scheduleSaved:'Programma salvato',
    sunRuleSaved:'Regola salvata',
    impossibleDeleteRoom:'Impossibile eliminare',
    moveAccessoriesFirst:'Sposta prima gli accessori assegnati a questa stanza.'
   },
   routeTitles:{
    manageHome:'Gestisci casa',
    rooms:'Stanze',
    roomAdd:'Aggiungi stanza',
    invite:'Invita membro',
    modules:'Impostazioni Moduli',
    dashboardEdit:'Personalizza dashboard',
    dashboardAdd:'Aggiungi alla dashboard',
    devices:'Accessori',
    addDevice:'Aggiungi dispositivo',
    pairQr:'Scansiona codice QR',
    pairFound:'Modulo trovato',
    pairName:'Nome accessorio',
    pairRoom:'Stanza',
    pairInput:'Tipo di comando',
    pairDone:'Completato',
    habitName:'Crea abitudine',
    newHabit:'Nuova Abitudine',
    actions:'Esegui',
    onlyIf:'Solo se',
    when:'Quando',
    accessorySettings:'Impostazioni',
    renameAccessory:'Rinomina accessorio',
    newSchedule:'Nuovo programma',
    newRule:'Nuova regola'
   }
  }
 },
 en:{
  timeLocale:'en-US',
  ui:{
   liveDemo:'Live Demo',
   mobileCtaLabel:'Preview the App',
   hintTitle:'Try the demo preview',
   hintText:'Navigate and explore screens and controls.',
   defaultHeading:'Try Freedompro Home',
   defaultSubheading:'Control your home, try Habits and explore energy usage with the same navigation logic as the app.',
   appStoreAria:'Download on the App Store',
   appStoreAlt:'Download on the App Store',
   playStoreAria:'Get it on Google Play',
   playStoreAlt:'Get it on Google Play',
   nav:{home:'Home',accessories:'Accessories',habits:'Habits',consumption:'Consumption'},
   states:{
    active:'Active',
    inactive:'Inactive',
    on:'On',
    off:'Off',
    open:'Open',
    closed:'Closed'
   },
   home:{
    dashboard:'Dashboard',
    personalize:'Customize'
   },
   summary:{
    light:['Off','1 On','On'],
    shutter:['Closed','1 Open','Open'],
    outlet:['Off','1 On','On']
   },
   accessories:{
    searchPlaceholder:'Search',
    rooms:'Rooms',
    type:'Type',
    roomAll:'All',
    typeAll:'All',
    types:{light:'Lights',shutter:'Shutters',outlet:'Outlets',switch:'Contacts'},
    emptyTitle:'No accessories found',
    emptyText:'Try a different name, room or module.'
   },
   habits:{
    emptyTitle:'A new level of comfort with Habits',
    emptyText:'Set rules and actions to make your home even more comfortable.',
    promoTitle:'Discover the power of Habits',
    promoText:'Create smart automations for lights, shutters, outlets and much more.'
   },
   consumption:{
    segments:{day:'Day',week:'Week',month:'Month',year:'Year'},
    periods:{day:'Today',week:'This week',month:'June 2026',year:'2026'},
    totalPrefix:'Total:',
    category:'Type',
    categoryAll:'All',
    categories:{light:'Lights',shutter:'Shutters',outlet:'Outlets'}
   },
   common:{
    cancel:'Cancel',
    confirm:'Confirm',
    save:'Save',
    done:'Done',
    add:'Add',
    create:'Create',
    continue:'Continue',
    next:'Next',
    ok:'OK',
    delete:'Delete',
    rename:'Rename',
    module:'Module',
    room:'Room',
    accessory:'Accessory',
    schedule:'Schedule',
    sunriseSunset:'Sunrise and sunset',
    configure:'Configure',
    unavailable:'Screen unavailable'
   },
   toasts:{
    officialApp:'Discover the full potential of the official Freedompro App',
    currentPeriod:'You are already in the current period',
    itemsAdded:'Items added to the Dashboard',
    copiedLink:'Link copied',
    homeRenamed:'Home renamed',
    simulatedAction:'Simulated action',
    moduleRenamed:'Module renamed',
    moduleRemoved:'Module removed',
    accessoryRenamed:'Accessory renamed',
    scheduleDeleted:'Schedule deleted',
    sunRuleDeleted:'Rule deleted',
    demoReset:'Demo reset',
    habitSaved:'Habit saved',
    habitDisabled:'Habit inactive',
    habitExecuted:'executed',
    roomAdded:'Room added',
    roomUpdated:'Room updated',
    roomDeleted:'Room deleted',
    accessoryAdded:'Accessory added',
    scheduleSaved:'Schedule saved',
    sunRuleSaved:'Rule saved',
    impossibleDeleteRoom:'Cannot delete',
    moveAccessoriesFirst:'Move the accessories assigned to this room first.'
   },
   routeTitles:{
    manageHome:'Manage home',
    rooms:'Rooms',
    roomAdd:'Add room',
    invite:'Invite member',
    modules:'Module settings',
    dashboardEdit:'Customize dashboard',
    dashboardAdd:'Add to dashboard',
    devices:'Accessories',
    addDevice:'Add device',
    pairQr:'Scan QR code',
    pairFound:'Module found',
    pairName:'Accessory name',
    pairRoom:'Room',
    pairInput:'Control type',
    pairDone:'Completed',
    habitName:'Create habit',
    newHabit:'New Habit',
    actions:'Run',
    onlyIf:'Only if',
    when:'When',
    accessorySettings:'Settings',
    renameAccessory:'Rename accessory',
    newSchedule:'New schedule',
    newRule:'New rule'
   }
  }
 },
 es:{
  timeLocale:'es-ES',
  ui:{
   liveDemo:'Demo en vivo',
   mobileCtaLabel:'Vista previa de la App',
   hintTitle:'Prueba la vista previa de la demo',
   hintText:'Navega y explora pantallas y controles.',
   defaultHeading:'Prueba Freedompro Home',
   defaultSubheading:'Controla tu casa, prueba las Rutinas y descubre el consumo con la misma lógica de navegación de la app.',
   appStoreAria:'Descargar en el App Store',
   appStoreAlt:'Descargar en el App Store',
   playStoreAria:'Disponible en Google Play',
   playStoreAlt:'Disponible en Google Play',
   nav:{home:'Inicio',accessories:'Accesorios',habits:'Rutinas',consumption:'Consumo'},
   states:{
    active:'Activa',
    inactive:'Inactiva',
    on:'Encendido',
    off:'Apagado',
    open:'Abierta',
    closed:'Cerrada'
   },
   home:{
    dashboard:'Panel',
    personalize:'Personaliza'
   },
   summary:{
    light:['Apagadas','1 Encendida','Encendidas'],
    shutter:['Cerradas','1 Abierta','Abiertas'],
    outlet:['Apagadas','1 Encendida','Encendidas']
   },
   accessories:{
    searchPlaceholder:'Buscar',
    rooms:'Estancias',
    type:'Tipo',
    roomAll:'Todos',
    typeAll:'Todos',
    types:{light:'Luces',shutter:'Persianas',outlet:'Enchufes',switch:'Contactos'},
    emptyTitle:'No se han encontrado accesorios',
    emptyText:'Prueba con otro nombre, estancia o módulo.'
   },
   habits:{
    emptyTitle:'Un nuevo confort con las Rutinas',
    emptyText:'Configura reglas y acciones para que tu casa sea aún más cómoda.',
    promoTitle:'Descubre el poder de las Rutinas',
    promoText:'Crea automatizaciones inteligentes para luces, persianas, enchufes y mucho más.'
   },
   consumption:{
    segments:{day:'Día',week:'Semana',month:'Mes',year:'Año'},
    periods:{day:'Hoy',week:'Esta semana',month:'junio de 2026',year:'2026'},
    totalPrefix:'Total:',
    category:'Tipo',
    categoryAll:'Todos',
    categories:{light:'Luces',shutter:'Persianas',outlet:'Enchufes'}
   },
   common:{
    cancel:'Cancelar',
    confirm:'Confirmar',
    save:'Guardar',
    done:'Hecho',
    add:'Añadir',
    create:'Crear',
    continue:'Continuar',
    next:'Siguiente',
    ok:'OK',
    delete:'Eliminar',
    rename:'Renombrar',
    module:'Módulo',
    room:'Estancia',
    accessory:'Accesorio',
    schedule:'Programa',
    sunriseSunset:'Amanecer y atardecer',
    configure:'Configurar',
    unavailable:'Pantalla no disponible'
   },
   toasts:{
    officialApp:'Descubre todo el potencial de la App oficial de Freedompro',
    currentPeriod:'Ya estás en el período actual',
    itemsAdded:'Elementos añadidos al panel',
    copiedLink:'Enlace copiado',
    homeRenamed:'Casa renombrada',
    simulatedAction:'Acción simulada',
    moduleRenamed:'Módulo renombrado',
    moduleRemoved:'Módulo eliminado',
    accessoryRenamed:'Accesorio renombrado',
    scheduleDeleted:'Programación eliminada',
    sunRuleDeleted:'Regla eliminada',
    demoReset:'Demo restablecida',
    habitSaved:'Rutina guardada',
    habitDisabled:'Rutina inactiva',
    habitExecuted:'ejecutada',
    roomAdded:'Estancia añadida',
    roomUpdated:'Estancia actualizada',
    roomDeleted:'Estancia eliminada',
    accessoryAdded:'Accesorio añadido',
    scheduleSaved:'Programa guardado',
    sunRuleSaved:'Regla guardada',
    impossibleDeleteRoom:'No se puede eliminar',
    moveAccessoriesFirst:'Mueve primero los accesorios asignados a esta estancia.'
   },
   routeTitles:{
    manageHome:'Gestionar casa',
    rooms:'Estancias',
    roomAdd:'Añadir estancia',
    invite:'Invitar miembro',
    modules:'Configuración de módulos',
    dashboardEdit:'Personalizar panel',
    dashboardAdd:'Añadir al panel',
    devices:'Accesorios',
    addDevice:'Añadir dispositivo',
    pairQr:'Escanear código QR',
    pairFound:'Módulo encontrado',
    pairName:'Nombre del accesorio',
    pairRoom:'Estancia',
    pairInput:'Tipo de control',
    pairDone:'Completado',
    habitName:'Crear rutina',
    newHabit:'Nueva Rutina',
    actions:'Ejecutar',
    onlyIf:'Solo si',
    when:'Cuando',
    accessorySettings:'Ajustes',
    renameAccessory:'Renombrar accesorio',
    newSchedule:'Nuevo programa',
    newRule:'Nueva regla'
   }
  }
 },
 de:{
  timeLocale:'de-DE',
  ui:{
   liveDemo:'Live-Demo',
   mobileCtaLabel:'App-Vorschau',
   hintTitle:'Teste die Demo-Vorschau',
   hintText:'Navigiere und entdecke Ansichten und Steuerelemente.',
   defaultHeading:'Teste Freedompro Home',
   defaultSubheading:'Steuere dein Zuhause, probiere Routinen aus und entdecke den Verbrauch mit derselben Navigationslogik wie in der App.',
   appStoreAria:'Im App Store laden',
   appStoreAlt:'Im App Store laden',
   playStoreAria:'Bei Google Play erhältlich',
   playStoreAlt:'Bei Google Play erhältlich',
   nav:{home:'Start',accessories:'Geräte',habits:'Routinen',consumption:'Verbrauch'},
   states:{
    active:'Aktiv',
    inactive:'Inaktiv',
    on:'Ein',
    off:'Aus',
    open:'Offen',
    closed:'Geschlossen'
   },
   home:{
    dashboard:'Dashboard',
    personalize:'Anpassen'
   },
   summary:{
    light:['Aus','1 Ein','Ein'],
    shutter:['Geschlossen','1 Offen','Offen'],
    outlet:['Aus','1 Ein','Ein']
   },
   accessories:{
    searchPlaceholder:'Suchen',
    rooms:'Räume',
    type:'Typ',
    roomAll:'Alle',
    typeAll:'Alle',
    types:{light:'Lichter',shutter:'Rollläden',outlet:'Steckdosen',switch:'Kontakte'},
    emptyTitle:'Keine Geräte gefunden',
    emptyText:'Versuche es mit einem anderen Namen, Raum oder Modul.'
   },
   habits:{
    emptyTitle:'Mehr Komfort mit Routinen',
    emptyText:'Lege Regeln und Aktionen fest, um dein Zuhause noch komfortabler zu machen.',
    promoTitle:'Entdecke die Stärke von Routinen',
    promoText:'Erstelle smarte Automationen für Lichter, Rollläden, Steckdosen und vieles mehr.'
   },
   consumption:{
    segments:{day:'Tag',week:'Woche',month:'Monat',year:'Jahr'},
    periods:{day:'Heute',week:'Diese Woche',month:'Juni 2026',year:'2026'},
    totalPrefix:'Gesamt:',
    category:'Typ',
    categoryAll:'Alle',
    categories:{light:'Lichter',shutter:'Rollläden',outlet:'Steckdosen'}
   },
   common:{
    cancel:'Abbrechen',
    confirm:'Bestätigen',
    save:'Speichern',
    done:'Fertig',
    add:'Hinzufügen',
    create:'Erstellen',
    continue:'Weiter',
    next:'Weiter',
    ok:'OK',
    delete:'Löschen',
    rename:'Umbenennen',
    module:'Modul',
    room:'Raum',
    accessory:'Gerät',
    schedule:'Zeitplan',
    sunriseSunset:'Sonnenaufgang und Sonnenuntergang',
    configure:'Konfigurieren',
    unavailable:'Ansicht nicht verfügbar'
   },
   toasts:{
    officialApp:'Entdecke das volle Potenzial der offiziellen Freedompro App',
    currentPeriod:'Du befindest dich bereits im aktuellen Zeitraum',
    itemsAdded:'Elemente zum Dashboard hinzugefügt',
    copiedLink:'Link kopiert',
    homeRenamed:'Zuhause umbenannt',
    simulatedAction:'Simulierte Aktion',
    moduleRenamed:'Modul umbenannt',
    moduleRemoved:'Modul entfernt',
    accessoryRenamed:'Gerät umbenannt',
    scheduleDeleted:'Zeitplan gelöscht',
    sunRuleDeleted:'Regel gelöscht',
    demoReset:'Demo zurückgesetzt',
    habitSaved:'Routine gespeichert',
    habitDisabled:'Routine inaktiv',
    habitExecuted:'ausgeführt',
    roomAdded:'Raum hinzugefügt',
    roomUpdated:'Raum aktualisiert',
    roomDeleted:'Raum gelöscht',
    accessoryAdded:'Gerät hinzugefügt',
    scheduleSaved:'Zeitplan gespeichert',
    sunRuleSaved:'Regel gespeichert',
    impossibleDeleteRoom:'Löschen nicht möglich',
    moveAccessoriesFirst:'Verschiebe zuerst die diesem Raum zugewiesenen Geräte.'
   },
   routeTitles:{
    manageHome:'Zuhause verwalten',
    rooms:'Räume',
    roomAdd:'Raum hinzufügen',
    invite:'Mitglied einladen',
    modules:'Moduleinstellungen',
    dashboardEdit:'Dashboard anpassen',
    dashboardAdd:'Zum Dashboard hinzufügen',
    devices:'Geräte',
    addDevice:'Gerät hinzufügen',
    pairQr:'QR-Code scannen',
    pairFound:'Modul gefunden',
    pairName:'Gerätename',
    pairRoom:'Raum',
    pairInput:'Steuerungstyp',
    pairDone:'Abgeschlossen',
    habitName:'Routine erstellen',
    newHabit:'Neue Routine',
    actions:'Ausführen',
    onlyIf:'Nur wenn',
    when:'Wenn',
    accessorySettings:'Einstellungen',
    renameAccessory:'Gerät umbenennen',
    newSchedule:'Neuer Zeitplan',
    newRule:'Neue Regel'
   }
  }
 },
 fr:{
  timeLocale:'fr-FR',
  ui:{
   liveDemo:'Démo en direct',
   mobileCtaLabel:"Aperçu de l’App",
   hintTitle:'Essayez l’aperçu de la démo',
   hintText:'Naviguez et explorez les écrans et les commandes.',
   defaultHeading:'Essayez Freedompro Home',
   defaultSubheading:'Contrôlez votre maison, testez les Habitudes et découvrez la consommation avec la même logique de navigation que dans l’app.',
   appStoreAria:"Télécharger sur l'App Store",
   appStoreAlt:"Télécharger sur l'App Store",
   playStoreAria:'Disponible sur Google Play',
   playStoreAlt:'Disponible sur Google Play',
   nav:{home:'Accueil',accessories:'Accessoires',habits:'Habitudes',consumption:'Consommation'},
   states:{
    active:'Active',
    inactive:'Inactive',
    on:'Allumé',
    off:'Éteint',
    open:'Ouverte',
    closed:'Fermée'
   },
   home:{
    dashboard:'Tableau de bord',
    personalize:'Personnaliser'
   },
   summary:{
    light:['Éteintes','1 Allumée','Allumées'],
    shutter:['Fermées','1 Ouverte','Ouvertes'],
    outlet:['Éteintes','1 Allumée','Allumées']
   },
   accessories:{
    searchPlaceholder:'Rechercher',
    rooms:'Pièces',
    type:'Type',
    roomAll:'Tous',
    typeAll:'Tous',
    types:{light:'Lumières',shutter:'Volets',outlet:'Prises',switch:'Contacts'},
    emptyTitle:'Aucun accessoire trouvé',
    emptyText:'Essayez un autre nom, une autre pièce ou un autre module.'
   },
   habits:{
    emptyTitle:'Un nouveau confort avec les Habitudes',
    emptyText:'Définissez des règles et des actions pour rendre votre maison encore plus confortable.',
    promoTitle:'Découvrez la puissance des Habitudes',
    promoText:'Créez des automatisations intelligentes pour les lumières, volets, prises et bien plus encore.'
   },
   consumption:{
    segments:{day:'Jour',week:'Semaine',month:'Mois',year:'Année'},
    periods:{day:"Aujourd’hui",week:'Cette semaine',month:'juin 2026',year:'2026'},
    totalPrefix:'Total :',
    category:'Type',
    categoryAll:'Tous',
    categories:{light:'Lumières',shutter:'Volets',outlet:'Prises'}
   },
   common:{
    cancel:'Annuler',
    confirm:'Confirmer',
    save:'Enregistrer',
    done:'Terminé',
    add:'Ajouter',
    create:'Créer',
    continue:'Continuer',
    next:'Suivant',
    ok:'OK',
    delete:'Supprimer',
    rename:'Renommer',
    module:'Module',
    room:'Pièce',
    accessory:'Accessoire',
    schedule:'Programme',
    sunriseSunset:'Lever et coucher du soleil',
    configure:'Configurer',
    unavailable:'Écran indisponible'
   },
   toasts:{
    officialApp:"Découvrez tout le potentiel de l’App officielle Freedompro",
    currentPeriod:'Vous êtes déjà sur la période en cours',
    itemsAdded:'Éléments ajoutés au tableau de bord',
    copiedLink:'Lien copié',
    homeRenamed:'Maison renommée',
    simulatedAction:'Action simulée',
    moduleRenamed:'Module renommé',
    moduleRemoved:'Module supprimé',
    accessoryRenamed:'Accessoire renommé',
    scheduleDeleted:'Programme supprimé',
    sunRuleDeleted:'Règle supprimée',
    demoReset:'Démo réinitialisée',
    habitSaved:'Habitude enregistrée',
    habitDisabled:'Habitude inactive',
    habitExecuted:'exécutée',
    roomAdded:'Pièce ajoutée',
    roomUpdated:'Pièce mise à jour',
    roomDeleted:'Pièce supprimée',
    accessoryAdded:'Accessoire ajouté',
    scheduleSaved:'Programme enregistré',
    sunRuleSaved:'Règle enregistrée',
    impossibleDeleteRoom:'Suppression impossible',
    moveAccessoriesFirst:'Déplacez d’abord les accessoires attribués à cette pièce.'
   },
   routeTitles:{
    manageHome:'Gérer la maison',
    rooms:'Pièces',
    roomAdd:'Ajouter une pièce',
    invite:'Inviter un membre',
    modules:'Paramètres des modules',
    dashboardEdit:'Personnaliser le tableau de bord',
    dashboardAdd:'Ajouter au tableau de bord',
    devices:'Accessoires',
    addDevice:'Ajouter un appareil',
    pairQr:'Scanner le code QR',
    pairFound:'Module trouvé',
    pairName:'Nom de l’accessoire',
    pairRoom:'Pièce',
    pairInput:'Type de commande',
    pairDone:'Terminé',
    habitName:'Créer une habitude',
    newHabit:'Nouvelle Habitude',
    actions:'Exécuter',
    onlyIf:'Seulement si',
    when:'Quand',
    accessorySettings:'Paramètres',
    renameAccessory:'Renommer l’accessoire',
    newSchedule:'Nouveau programme',
    newRule:'Nouvelle règle'
   }
  }
 }
};

function mergeCopy(base,override){
 const output={...base};
 Object.keys(override||{}).forEach(key=>{
  const baseValue=base?.[key];
  const overrideValue=override[key];
  if(baseValue&&typeof baseValue==='object'&&!Array.isArray(baseValue)&&overrideValue&&typeof overrideValue==='object'&&!Array.isArray(overrideValue)){
   output[key]=mergeCopy(baseValue,overrideValue);
  }else{
   output[key]=overrideValue;
  }
 });
 return output;
}

function resolveDemoLocale(rawLocale){
 const normalized=String(rawLocale||'').toLowerCase();
 const short=normalized.split('-')[0];
 return DEMO_COPY[normalized]?normalized:(DEMO_COPY[short]?short:'it');
}

function getDemoCopy(locale){
 const resolved=resolveDemoLocale(locale);
 return mergeCopy(DEMO_COPY.it,DEMO_COPY[resolved]||{});
}

const DEMO_FLOW_COPY={
 it:{
  manageHome:{renameHome:'Rinomina la casa',configuredRooms:'stanze configurate',inviteMember:'Invita membro',shareHomeAccess:'Condividi l’accesso alla casa',moduleSettings:'Impostazioni Moduli',renameOrRemoveModules:'Rinomina o rimuovi i moduli',deleteHome:'Elimina casa',simulatedOperation:'Operazione simulata'},
  room:{whatName:'Come si chiama la stanza?',enterName:'Inserisci nome stanza',roomName:'Nome stanza',deleteRoom:'Elimina stanza',presets:['Soggiorno','Cucina','Camera','Bagno']},
  invite:{title:'Invita una persona',body:'Condividi questo link privato. Nell’app reale il destinatario apre il collegamento e conferma l’ingresso nella casa.',inviteLink:'Link di invito',copyLink:'Copia link'},
  module:{name:'Nome modulo',serial:'Seriale',remove:'Rimuovi Modulo'},
  dashboard:{tapMinus:'Tocca − per rimuovere',addToDashboard:'Aggiungi alla dashboard',devicesDetail:'Luci, tapparelle, prese e contatti',roomsDetail:'Aggiungi un collegamento alla stanza',habitsDetail:'Avvio rapido dalla Dashboard',noItems:'Nessun elemento disponibile'},
  pairing:{smartModules:'Moduli Smart',compatibleModule:'Aggiungi un nuovo modulo compatibile',easykonInfo:'Easykon segue un percorso dedicato e non utilizza Matter.',isNew:'Il modulo è nuovo?',choosePath:'Scegli il percorso corretto per aggiungere il dispositivo a Freedompro Home.',newModule:'No, è nuovo',alreadyConfigured:'Sì, è già configurato',alreadyConfiguredTitle:'Modulo già abbinato',alreadyConfiguredText:'Nell’app viene richiesto il codice Matter temporaneo generato dall’altro ecosistema.',scanQr:'Scansiona codice QR',useMatterCode:'Usa il codice Matter presente sul modulo o nella confezione.',letsStart:'Iniziamo',systemPairing:'Il sistema sta collegando il modulo alla rete e aggiungendo Freedompro Home come amministratore Matter.',finish:'Fine',foundReady:'Modulo trovato e pronto per la configurazione dell’accessorio.',nameQuestion:'Come vuoi chiamare l’accessorio?',accessoryName:'Nome accessorio',roomQuestion:'In quale stanza si trova?',commandType:'Tipo di comando',goToAccessories:'Vai agli accessori',addedTo:'L’accessorio è stato aggiunto a',withCommand:'con comando',types:['Interruttore','Pulsante','Pulsante modalità ciclica','Sensore','Sensore invertito','Nessuno']},
  habits:{nameQuestion:'Come si chiama questa abitudine?',placeholderExample:"Es. 'Buonanotte', 'Esco di casa'...",when:'Quando',whenHelp:'Aggiungi almeno una condizione di avvio.',onlyIf:'Solo se',onlyIfHelp:'Aggiungi ulteriori controlli alle condizioni di avvio.',run:'Esegui',runHelp:'Aggiungi uno o più eventi da riprodurre in sequenza.',addCondition:'Aggiungi condizione',addEvent:'Aggiungi evento'},
  overlay:{manageHome:'Gestisci Casa',notificationCenter:'Centro notifiche',addDevice:'Aggiungi dispositivo',addRoom:'Aggiungi stanza',createHabit:'Crea abitudine',addUser:'Aggiungi utente',addNfcTag:'Aggiungi Tag NFC',createHome:'Crea nuova casa',open:'Aperta',closed:'Chiusa',rename:'Rinomina',editName:'Modifica il nome',enable:'Attiva',disable:'Disattiva',makeAvailable:'Rendi disponibile l’Abitudine',preventAuto:'Impedisci l’avvio automatico',delete:'Elimina',removeHabit:'Rimuovi l’Abitudine'}
 },
 en:{
  manageHome:{renameHome:'Rename home',configuredRooms:'configured rooms',inviteMember:'Invite member',shareHomeAccess:'Share home access',moduleSettings:'Module settings',renameOrRemoveModules:'Rename or remove modules',deleteHome:'Delete home',simulatedOperation:'Simulated action'},
  room:{whatName:'What is the room name?',enterName:'Enter room name',roomName:'Room name',deleteRoom:'Delete room',presets:['Living room','Kitchen','Bedroom','Bathroom']},
  invite:{title:'Invite a person',body:'Share this private link. In the real app, the recipient opens the link and confirms access to the home.',inviteLink:'Invite link',copyLink:'Copy link'},
  module:{name:'Module name',serial:'Serial',remove:'Remove Module'},
  dashboard:{tapMinus:'Tap − to remove',addToDashboard:'Add to dashboard',devicesDetail:'Lights, shutters, outlets and contacts',roomsDetail:'Add a shortcut to the room',habitsDetail:'Quick launch from the Dashboard',noItems:'No items available'},
  pairing:{smartModules:'Smart Modules',compatibleModule:'Add a new compatible module',easykonInfo:'Easykon follows a dedicated path and does not use Matter.',isNew:'Is the module new?',choosePath:'Choose the correct path to add the device to Freedompro Home.',newModule:'No, it is new',alreadyConfigured:'Yes, it is already configured',alreadyConfiguredTitle:'Module already paired',alreadyConfiguredText:'In the app, the temporary Matter code generated by the other ecosystem is required.',scanQr:'Scan QR code',useMatterCode:'Use the Matter code on the module or packaging.',letsStart:"Let's begin",systemPairing:'The system is connecting the module to the network and adding Freedompro Home as Matter administrator.',finish:'Finish',foundReady:'Module found and ready for accessory setup.',nameQuestion:'What do you want to call the accessory?',accessoryName:'Accessory name',roomQuestion:'Which room is it in?',commandType:'Control type',goToAccessories:'Go to accessories',addedTo:'The accessory has been added to',withCommand:'with control',types:['Switch','Button','Cycling button mode','Sensor','Inverted sensor','None']},
  habits:{nameQuestion:'What is this habit called?',placeholderExample:"E.g. 'Good night', 'Leaving home'...",when:'When',whenHelp:'Add at least one start condition.',onlyIf:'Only if',onlyIfHelp:'Add extra checks to the start conditions.',run:'Run',runHelp:'Add one or more events to play in sequence.',addCondition:'Add condition',addEvent:'Add event'},
  overlay:{manageHome:'Manage Home',notificationCenter:'Notification center',addDevice:'Add device',addRoom:'Add room',createHabit:'Create habit',addUser:'Add user',addNfcTag:'Add NFC tag',createHome:'Create new home',open:'Open',closed:'Closed',rename:'Rename',editName:'Edit the name',enable:'Enable',disable:'Disable',makeAvailable:'Make the Habit available',preventAuto:'Prevent automatic start',delete:'Delete',removeHabit:'Remove the Habit'}
 },
 es:{
  manageHome:{renameHome:'Renombrar la casa',configuredRooms:'estancias configuradas',inviteMember:'Invitar miembro',shareHomeAccess:'Compartir acceso a la casa',moduleSettings:'Configuración de módulos',renameOrRemoveModules:'Renombra o elimina los módulos',deleteHome:'Eliminar casa',simulatedOperation:'Acción simulada'},
  room:{whatName:'¿Cómo se llama la estancia?',enterName:'Introduce el nombre de la estancia',roomName:'Nombre de la estancia',deleteRoom:'Eliminar estancia',presets:['Salón','Cocina','Dormitorio','Baño']},
  invite:{title:'Invitar a una persona',body:'Comparte este enlace privado. En la app real, el destinatario abre el enlace y confirma el acceso a la casa.',inviteLink:'Enlace de invitación',copyLink:'Copiar enlace'},
  module:{name:'Nombre del módulo',serial:'Serie',remove:'Eliminar módulo'},
  dashboard:{tapMinus:'Pulsa − para eliminar',addToDashboard:'Añadir al panel',devicesDetail:'Luces, persianas, enchufes y contactos',roomsDetail:'Añade un acceso directo a la estancia',habitsDetail:'Inicio rápido desde el panel',noItems:'No hay elementos disponibles'},
  pairing:{smartModules:'Módulos Smart',compatibleModule:'Añadir un nuevo módulo compatible',easykonInfo:'Easykon sigue un flujo dedicado y no utiliza Matter.',isNew:'¿El módulo es nuevo?',choosePath:'Elige el flujo correcto para añadir el dispositivo a Freedompro Home.',newModule:'No, es nuevo',alreadyConfigured:'Sí, ya está configurado',alreadyConfiguredTitle:'Módulo ya vinculado',alreadyConfiguredText:'En la app se solicita el código Matter temporal generado por el otro ecosistema.',scanQr:'Escanear código QR',useMatterCode:'Usa el código Matter presente en el módulo o en la caja.',letsStart:'Empecemos',systemPairing:'El sistema está conectando el módulo a la red y añadiendo Freedompro Home como administrador Matter.',finish:'Finalizar',foundReady:'Módulo encontrado y listo para configurar el accesorio.',nameQuestion:'¿Cómo quieres llamar al accesorio?',accessoryName:'Nombre del accesorio',roomQuestion:'¿En qué estancia se encuentra?',commandType:'Tipo de control',goToAccessories:'Ir a accesorios',addedTo:'El accesorio se ha añadido a',withCommand:'con control',types:['Interruptor','Pulsador','Pulsador modo cíclico','Sensor','Sensor invertido','Ninguno']},
  habits:{nameQuestion:'¿Cómo se llama esta rutina?',placeholderExample:"Por ej. 'Buenas noches', 'Salgo de casa'...",when:'Cuándo',whenHelp:'Añade al menos una condición de inicio.',onlyIf:'Solo si',onlyIfHelp:'Añade comprobaciones adicionales a las condiciones de inicio.',run:'Ejecutar',runHelp:'Añade uno o más eventos para reproducir en secuencia.',addCondition:'Añadir condición',addEvent:'Añadir evento'},
  overlay:{manageHome:'Gestionar casa',notificationCenter:'Centro de notificaciones',addDevice:'Añadir dispositivo',addRoom:'Añadir estancia',createHabit:'Crear rutina',addUser:'Añadir usuario',addNfcTag:'Añadir etiqueta NFC',createHome:'Crear nueva casa',open:'Abierta',closed:'Cerrada',rename:'Renombrar',editName:'Modificar el nombre',enable:'Activar',disable:'Desactivar',makeAvailable:'Hacer disponible la rutina',preventAuto:'Impedir el inicio automático',delete:'Eliminar',removeHabit:'Eliminar la rutina'}
 },
 de:{
  manageHome:{renameHome:'Zuhause umbenennen',configuredRooms:'konfigurierte Räume',inviteMember:'Mitglied einladen',shareHomeAccess:'Zugang zum Zuhause teilen',moduleSettings:'Moduleinstellungen',renameOrRemoveModules:'Module umbenennen oder entfernen',deleteHome:'Zuhause löschen',simulatedOperation:'Simulierte Aktion'},
  room:{whatName:'Wie heißt der Raum?',enterName:'Raumnamen eingeben',roomName:'Raumname',deleteRoom:'Raum löschen',presets:['Wohnzimmer','Küche','Schlafzimmer','Bad']},
  invite:{title:'Person einladen',body:'Teile diesen privaten Link. In der echten App öffnet der Empfänger den Link und bestätigt den Zugang zum Zuhause.',inviteLink:'Einladungslink',copyLink:'Link kopieren'},
  module:{name:'Modulname',serial:'Seriennummer',remove:'Modul entfernen'},
  dashboard:{tapMinus:'Tippe auf − zum Entfernen',addToDashboard:'Zum Dashboard hinzufügen',devicesDetail:'Lichter, Rollläden, Steckdosen und Kontakte',roomsDetail:'Einen Schnellzugriff zum Raum hinzufügen',habitsDetail:'Schnellstart vom Dashboard',noItems:'Keine Elemente verfügbar'},
  pairing:{smartModules:'Smarte Module',compatibleModule:'Ein neues kompatibles Modul hinzufügen',easykonInfo:'Easykon folgt einem eigenen Ablauf und nutzt Matter nicht.',isNew:'Ist das Modul neu?',choosePath:'Wähle den richtigen Ablauf, um das Gerät zu Freedompro Home hinzuzufügen.',newModule:'Nein, es ist neu',alreadyConfigured:'Ja, es ist bereits eingerichtet',alreadyConfiguredTitle:'Modul bereits gekoppelt',alreadyConfiguredText:'In der App wird der temporäre Matter-Code verlangt, der vom anderen Ökosystem erzeugt wurde.',scanQr:'QR-Code scannen',useMatterCode:'Nutze den Matter-Code auf dem Modul oder der Verpackung.',letsStart:'Los geht’s',systemPairing:'Das System verbindet das Modul mit dem Netzwerk und fügt Freedompro Home als Matter-Administrator hinzu.',finish:'Fertig',foundReady:'Modul gefunden und bereit für die Konfiguration des Geräts.',nameQuestion:'Wie soll das Gerät heißen?',accessoryName:'Gerätename',roomQuestion:'In welchem Raum befindet es sich?',commandType:'Steuerungstyp',goToAccessories:'Zu den Geräten',addedTo:'Das Gerät wurde hinzugefügt zu',withCommand:'mit Steuerung',types:['Schalter','Taster','Taster mit Zyklusmodus','Sensor','Invertierter Sensor','Keine']},
  habits:{nameQuestion:'Wie heißt diese Routine?',placeholderExample:"Z. B. 'Gute Nacht', 'Ich verlasse das Haus'...",when:'Wenn',whenHelp:'Füge mindestens eine Startbedingung hinzu.',onlyIf:'Nur wenn',onlyIfHelp:'Füge zusätzliche Prüfungen zu den Startbedingungen hinzu.',run:'Ausführen',runHelp:'Füge ein oder mehrere Ereignisse hinzu, die nacheinander abgespielt werden.',addCondition:'Bedingung hinzufügen',addEvent:'Ereignis hinzufügen'},
  overlay:{manageHome:'Zuhause verwalten',notificationCenter:'Benachrichtigungszentrale',addDevice:'Gerät hinzufügen',addRoom:'Raum hinzufügen',createHabit:'Routine erstellen',addUser:'Benutzer hinzufügen',addNfcTag:'NFC-Tag hinzufügen',createHome:'Neues Zuhause erstellen',open:'Offen',closed:'Geschlossen',rename:'Umbenennen',editName:'Namen ändern',enable:'Aktivieren',disable:'Deaktivieren',makeAvailable:'Routine verfügbar machen',preventAuto:'Automatischen Start verhindern',delete:'Löschen',removeHabit:'Routine entfernen'}
 },
 fr:{
  manageHome:{renameHome:'Renommer la maison',configuredRooms:'pièces configurées',inviteMember:'Inviter un membre',shareHomeAccess:'Partager l’accès à la maison',moduleSettings:'Paramètres des modules',renameOrRemoveModules:'Renommer ou supprimer les modules',deleteHome:'Supprimer la maison',simulatedOperation:'Action simulée'},
  room:{whatName:'Comment s’appelle la pièce ?',enterName:'Saisir le nom de la pièce',roomName:'Nom de la pièce',deleteRoom:'Supprimer la pièce',presets:['Salon','Cuisine','Chambre','Salle de bain']},
  invite:{title:'Inviter une personne',body:'Partagez ce lien privé. Dans l’app réelle, le destinataire ouvre le lien et confirme l’accès à la maison.',inviteLink:'Lien d’invitation',copyLink:'Copier le lien'},
  module:{name:'Nom du module',serial:'Série',remove:'Supprimer le module'},
  dashboard:{tapMinus:'Touchez − pour supprimer',addToDashboard:'Ajouter au tableau de bord',devicesDetail:'Lumières, volets, prises et contacts',roomsDetail:'Ajouter un raccourci à la pièce',habitsDetail:'Lancement rapide depuis le tableau de bord',noItems:'Aucun élément disponible'},
  pairing:{smartModules:'Modules Smart',compatibleModule:'Ajouter un nouveau module compatible',easykonInfo:'Easykon suit un parcours dédié et n’utilise pas Matter.',isNew:'Le module est-il neuf ?',choosePath:'Choisissez le bon parcours pour ajouter l’appareil à Freedompro Home.',newModule:'Non, il est neuf',alreadyConfigured:'Oui, il est déjà configuré',alreadyConfiguredTitle:'Module déjà associé',alreadyConfiguredText:'Dans l’app, le code Matter temporaire généré par l’autre écosystème est demandé.',scanQr:'Scanner le code QR',useMatterCode:'Utilisez le code Matter présent sur le module ou l’emballage.',letsStart:'Commençons',systemPairing:'Le système connecte le module au réseau et ajoute Freedompro Home comme administrateur Matter.',finish:'Terminer',foundReady:'Module trouvé et prêt pour la configuration de l’accessoire.',nameQuestion:'Comment voulez-vous appeler l’accessoire ?',accessoryName:'Nom de l’accessoire',roomQuestion:'Dans quelle pièce se trouve-t-il ?',commandType:'Type de commande',goToAccessories:'Aller aux accessoires',addedTo:'L’accessoire a été ajouté à',withCommand:'avec commande',types:['Interrupteur','Bouton-poussoir','Bouton-poussoir mode cyclique','Capteur','Capteur inversé','Aucun']},
  habits:{nameQuestion:'Comment s’appelle cette habitude ?',placeholderExample:"Ex. 'Bonne nuit', 'Je sors de la maison'...",when:'Quand',whenHelp:'Ajoutez au moins une condition de démarrage.',onlyIf:'Seulement si',onlyIfHelp:'Ajoutez d’autres contrôles aux conditions de démarrage.',run:'Exécuter',runHelp:'Ajoutez un ou plusieurs événements à exécuter en séquence.',addCondition:'Ajouter une condition',addEvent:'Ajouter un événement'},
  overlay:{manageHome:'Gérer la maison',notificationCenter:'Centre de notifications',addDevice:'Ajouter un appareil',addRoom:'Ajouter une pièce',createHabit:'Créer une habitude',addUser:'Ajouter un utilisateur',addNfcTag:'Ajouter un tag NFC',createHome:'Créer une nouvelle maison',open:'Ouverte',closed:'Fermée',rename:'Renommer',editName:'Modifier le nom',enable:'Activer',disable:'Désactiver',makeAvailable:'Rendre l’habitude disponible',preventAuto:'Empêcher le démarrage automatique',delete:'Supprimer',removeHabit:'Supprimer l’habitude'}
 }
};

function getFlowCopy(locale){
 const resolved=resolveDemoLocale(locale);
 return DEMO_FLOW_COPY[resolved]||DEMO_FLOW_COPY.it;
}

const DEMO_SEED_COPY={
 it:{home:{name:'MyHome',position:'Italia'},homeChoices:['MyHome','Casa Vacanze'],profile:{name:'Alessandro',subtitle:'Il mio profilo'},rooms:{living:'Soggiorno',kitchen:'Cucina',bedroom:'Camera',outside:'Esterno'},devices:{luceSoggiorno:'Luce soggiorno',luceCucina:'Luce cucina',luceCamera:'Luce camera',tapparellaSoggiorno:'Tapparella soggiorno',tapparellaCamera:'Tapparella camera',presaTV:'Presa TV',cancello:'Cancello',luceEsterna:'Luce esterna'},modules:{m1:'Modulo luci zona giorno',m2:'Modulo tapparella soggiorno',m3:'Modulo tapparella camera',m4:'Modulo presa TV',m5:'Modulo cancello'},habits:{habitExit:{name:'Esco di casa',summary:'Avvio manuale · 6 eventi',whenTitle:'Avvio manuale',whenDetail:'Dalla Dashboard'},habitNight:{name:'Buonanotte',summary:'Avvio manuale · 5 eventi',whenTitle:'Avvio manuale',whenDetail:'Dalla sezione Abitudini'}},pairing:{name:'Luce ingresso',room:'Soggiorno',input:'Interruttore'},modulePrefix:'Modulo'},
 en:{home:{name:'MyHome',position:'Italy'},homeChoices:['MyHome','Holiday Home'],profile:{name:'Alessandro',subtitle:'My profile'},rooms:{living:'Living room',kitchen:'Kitchen',bedroom:'Bedroom',outside:'Outdoor'},devices:{luceSoggiorno:'Living room light',luceCucina:'Kitchen light',luceCamera:'Bedroom light',tapparellaSoggiorno:'Living room shutter',tapparellaCamera:'Bedroom shutter',presaTV:'TV outlet',cancello:'Gate',luceEsterna:'Outdoor light'},modules:{m1:'Living area lights module',m2:'Living room shutter module',m3:'Bedroom shutter module',m4:'TV outlet module',m5:'Gate module'},habits:{habitExit:{name:'Leaving home',summary:'Manual start · 6 events',whenTitle:'Manual start',whenDetail:'From the Dashboard'},habitNight:{name:'Good night',summary:'Manual start · 5 events',whenTitle:'Manual start',whenDetail:'From the Habits section'}},pairing:{name:'Entrance light',room:'Living room',input:'Switch'},modulePrefix:'Module'},
 es:{home:{name:'MyHome',position:'Italia'},homeChoices:['MyHome','Casa de vacaciones'],profile:{name:'Alessandro',subtitle:'Mi perfil'},rooms:{living:'Salón',kitchen:'Cocina',bedroom:'Dormitorio',outside:'Exterior'},devices:{luceSoggiorno:'Luz del salón',luceCucina:'Luz de la cocina',luceCamera:'Luz del dormitorio',tapparellaSoggiorno:'Persiana del salón',tapparellaCamera:'Persiana del dormitorio',presaTV:'Enchufe TV',cancello:'Puerta',luceEsterna:'Luz exterior'},modules:{m1:'Módulo luces zona de día',m2:'Módulo persiana salón',m3:'Módulo persiana dormitorio',m4:'Módulo enchufe TV',m5:'Módulo puerta'},habits:{habitExit:{name:'Salgo de casa',summary:'Inicio manual · 6 eventos',whenTitle:'Inicio manual',whenDetail:'Desde el Panel'},habitNight:{name:'Buenas noches',summary:'Inicio manual · 5 eventos',whenTitle:'Inicio manual',whenDetail:'Desde la sección Rutinas'}},pairing:{name:'Luz de entrada',room:'Salón',input:'Interruptor'},modulePrefix:'Módulo'},
 de:{home:{name:'MyHome',position:'Italien'},homeChoices:['MyHome','Ferienhaus'],profile:{name:'Alessandro',subtitle:'Mein Profil'},rooms:{living:'Wohnzimmer',kitchen:'Küche',bedroom:'Schlafzimmer',outside:'Außenbereich'},devices:{luceSoggiorno:'Wohnzimmerlicht',luceCucina:'Küchenlicht',luceCamera:'Schlafzimmerlicht',tapparellaSoggiorno:'Rollladen Wohnzimmer',tapparellaCamera:'Rollladen Schlafzimmer',presaTV:'TV-Steckdose',cancello:'Tor',luceEsterna:'Außenlicht'},modules:{m1:'Modul Lichter Wohnbereich',m2:'Modul Rollladen Wohnzimmer',m3:'Modul Rollladen Schlafzimmer',m4:'Modul TV-Steckdose',m5:'Modul Tor'},habits:{habitExit:{name:'Ich verlasse das Haus',summary:'Manueller Start · 6 Ereignisse',whenTitle:'Manueller Start',whenDetail:'Vom Dashboard'},habitNight:{name:'Gute Nacht',summary:'Manueller Start · 5 Ereignisse',whenTitle:'Manueller Start',whenDetail:'Aus dem Bereich Routinen'}},pairing:{name:'Eingangslicht',room:'Wohnzimmer',input:'Schalter'},modulePrefix:'Modul'},
 fr:{home:{name:'MyHome',position:'Italie'},homeChoices:['MyHome','Maison de vacances'],profile:{name:'Alessandro',subtitle:'Mon profil'},rooms:{living:'Salon',kitchen:'Cuisine',bedroom:'Chambre',outside:'Extérieur'},devices:{luceSoggiorno:'Lumière du salon',luceCucina:'Lumière de la cuisine',luceCamera:'Lumière de la chambre',tapparellaSoggiorno:'Volet du salon',tapparellaCamera:'Volet de la chambre',presaTV:'Prise TV',cancello:'Portail',luceEsterna:'Lumière extérieure'},modules:{m1:'Module lumières pièce de vie',m2:'Module volet salon',m3:'Module volet chambre',m4:'Module prise TV',m5:'Module portail'},habits:{habitExit:{name:'Je quitte la maison',summary:'Démarrage manuel · 6 événements',whenTitle:'Démarrage manuel',whenDetail:'Depuis le tableau de bord'},habitNight:{name:'Bonne nuit',summary:'Démarrage manuel · 5 événements',whenTitle:'Démarrage manuel',whenDetail:'Depuis la section Habitudes'}},pairing:{name:'Lumière d’entrée',room:'Salon',input:'Interrupteur'},modulePrefix:'Module'}
};

function buildDemoState(locale){
 const resolved=resolveDemoLocale(locale);
 const seed=DEMO_SEED_COPY[resolved]||DEMO_SEED_COPY.it;
 const copy=getDemoCopy(resolved);
 const state=clone(INITIAL);
 const roomNames=seed.rooms;
 const sourceRoomByName=Object.fromEntries(INITIAL.rooms.map(room=>[room.name,room.id]));
 state.home=clone(seed.home);
 state.homeChoices=clone(seed.homeChoices);
 state.profile=clone(seed.profile);
 state.rooms=state.rooms.map(room=>({...room,name:roomNames[room.id]||room.name}));
 state.devices=Object.fromEntries(Object.entries(state.devices).map(([key,device])=>{
  const localizedRoom=roomNames[sourceRoomByName[device.room]]||device.room;
  return [key,{...device,name:seed.devices[key]||device.name,room:localizedRoom}];
 }));
 state.modules=state.modules.map(module=>({...module,name:seed.modules[module.id]||module.name}));
 state.habits=state.habits.map(habit=>{
  const localized=seed.habits[habit.id];
  if(!localized)return habit;
  return {
   ...habit,
   name:localized.name,
   summary:localized.summary,
   when:habit.when.map(item=>item.kind==='manual'?{...item,title:localized.whenTitle,detail:localized.whenDetail}:item),
   actions:habit.actions.map(action=>action.kind==='action-accessory'?{...action,state:copy.ui.states.off}:action)
  };
 });
 state.pairing={...state.pairing,...seed.pairing};
 return state;
}

class FreedomproMaestroDemo extends HTMLElement{
 constructor(){
  super();
  this.attachShadow({mode:'open'});
  this.s=buildDemoState('it');
  this.routes=[];
  this.overlay=null;
  this.toastTimer=null;
  this.shutterTimer=null;
  this.longTimer=null;
  this.longTriggered=false;
  this.draggingShutter=null;
  this.dragPointerId=null;
  this.statusTimeTimer=null;
  this.locale='it';
  this.copy=getDemoCopy('it');
  this.flow=getFlowCopy('it');
  this.ready=false;
 }
 resolveLocale(){
  if(this.hasAttribute('locale'))return this.getAttribute('locale');
  if(typeof document!=='undefined')return document.documentElement.lang||'it';
  return 'it';
 }
 summaryText(kind,count){
  const variants=this.copy.ui.summary[kind];
  return count===0?variants[0]:count===1?variants[1]:`${count} ${variants[2]}`;
 }
 roomAccessoryText(count){
  return `${count} ${count===1?'accessorio':'accessori'}`;
 }
 roomAccessoryTextLocalized(count){
  if(this.locale==='en')return `${count} ${count===1?'accessory':'accessories'}`;
  if(this.locale==='es')return `${count} ${count===1?'accesorio':'accesorios'}`;
  if(this.locale==='de')return `${count} ${count===1?'Gerät':'Geräte'}`;
  if(this.locale==='fr')return `${count} ${count===1?'accessoire':'accessoires'}`;
  return this.roomAccessoryText(count);
 }
 localizedWeekdays(){
  if(this.locale==='en')return ['M','T','W','T','F','S','S'];
  if(this.locale==='es')return ['L','M','X','J','V','S','D'];
  if(this.locale==='de')return ['M','D','M','D','F','S','S'];
  if(this.locale==='fr')return ['L','M','M','J','V','S','D'];
  return ['L','M','M','G','V','S','D'];
 }
 habitCatalog(target){
  const groups={
   it:{
    actions:[
     {kind:'action-accessory',icon:'puzzle',title:'Accessorio',detail:'Esempio: Spegni tutte le luci'},
     {kind:'action-notification',icon:'notification',title:'Notifica',detail:'Esempio: Invia una notifica'},
     {kind:'action-wait',icon:'wait',title:'Attesa',detail:'Esempio: Attendi 5 minuti'},
     {kind:'action-habit',icon:'habits',title:'Abitudine',detail:'Esempio: Avvia Buonanotte'}
    ],
    onlyIf:[
     {kind:'query-accessory',icon:'puzzle',title:'Accessorio',detail:'Esempio: Solo se una Luce è accesa'},
     {kind:'query-consumption',icon:'battery',title:'Consumo istantaneo',detail:'Esempio: Il consumo è minore di 500W'},
     {kind:'query-daynight',icon:'moon',title:'Giorno o Notte',detail:'Esempio: Solo se è notte'},
     {kind:'query-module',icon:'module',title:'Modulo',detail:'Esempio: Solo se un Modulo è online'},
     {kind:'query-time',icon:'clock',title:'Orario',detail:'Esempio: Tra le 08:00 e le 14:59'}
    ],
    when:[
     {kind:'trigger-schedule',icon:'clock',title:'Programma',detail:'Esempio: Tutti i giorni alle 8:00'},
     {kind:'trigger-sun',icon:'sunset',title:'Alba o tramonto',detail:'Esempio: 10 minuti prima del tramonto'},
     {kind:'trigger-daynight',icon:'moon',title:'Giorno o Notte',detail:'Esempio: Quando è completamente buio'},
     {kind:'trigger-consumption',icon:'battery',title:'Consumo istantaneo',detail:'Esempio: Il consumo istantaneo è maggiore di 500W'},
     {kind:'trigger-accessory',icon:'puzzle',title:'Accessorio',detail:'Esempio: Quando una Luce viene accesa'},
     {kind:'trigger-module',icon:'module',title:'Modulo',detail:'Esempio: Quando un Modulo va offline'},
     {kind:'trigger-nfc',icon:'nfc',title:'Tag NFC',detail:'Esempio: Quando rilevo un Tag NFC'}
    ]
   },
   en:{
    actions:[
     {kind:'action-accessory',icon:'puzzle',title:'Accessory',detail:'Example: Turn off all lights'},
     {kind:'action-notification',icon:'notification',title:'Notification',detail:'Example: Send a notification'},
     {kind:'action-wait',icon:'wait',title:'Wait',detail:'Example: Wait 5 minutes'},
     {kind:'action-habit',icon:'habits',title:'Habit',detail:'Example: Start Good night'}
    ],
    onlyIf:[
     {kind:'query-accessory',icon:'puzzle',title:'Accessory',detail:'Example: Only if a light is on'},
     {kind:'query-consumption',icon:'battery',title:'Instant consumption',detail:'Example: Consumption is below 500W'},
     {kind:'query-daynight',icon:'moon',title:'Day or night',detail:'Example: Only if it is night'},
     {kind:'query-module',icon:'module',title:'Module',detail:'Example: Only if a module is online'},
     {kind:'query-time',icon:'clock',title:'Time',detail:'Example: Between 08:00 and 14:59'}
    ],
    when:[
     {kind:'trigger-schedule',icon:'clock',title:'Schedule',detail:'Example: Every day at 8:00'},
     {kind:'trigger-sun',icon:'sunset',title:'Sunrise or sunset',detail:'Example: 10 minutes before sunset'},
     {kind:'trigger-daynight',icon:'moon',title:'Day or night',detail:'Example: When it is fully dark'},
     {kind:'trigger-consumption',icon:'battery',title:'Instant consumption',detail:'Example: Instant consumption is above 500W'},
     {kind:'trigger-accessory',icon:'puzzle',title:'Accessory',detail:'Example: When a light turns on'},
     {kind:'trigger-module',icon:'module',title:'Module',detail:'Example: When a module goes offline'},
     {kind:'trigger-nfc',icon:'nfc',title:'NFC tag',detail:'Example: When I detect an NFC tag'}
    ]
   },
   es:{
    actions:[
     {kind:'action-accessory',icon:'puzzle',title:'Accesorio',detail:'Ejemplo: Apaga todas las luces'},
     {kind:'action-notification',icon:'notification',title:'Notificación',detail:'Ejemplo: Envía una notificación'},
     {kind:'action-wait',icon:'wait',title:'Espera',detail:'Ejemplo: Espera 5 minutos'},
     {kind:'action-habit',icon:'habits',title:'Rutina',detail:'Ejemplo: Inicia Buenas noches'}
    ],
    onlyIf:[
     {kind:'query-accessory',icon:'puzzle',title:'Accesorio',detail:'Ejemplo: Solo si una luz está encendida'},
     {kind:'query-consumption',icon:'battery',title:'Consumo instantáneo',detail:'Ejemplo: El consumo es inferior a 500W'},
     {kind:'query-daynight',icon:'moon',title:'Día o noche',detail:'Ejemplo: Solo si es de noche'},
     {kind:'query-module',icon:'module',title:'Módulo',detail:'Ejemplo: Solo si un módulo está online'},
     {kind:'query-time',icon:'clock',title:'Horario',detail:'Ejemplo: Entre las 08:00 y las 14:59'}
    ],
    when:[
     {kind:'trigger-schedule',icon:'clock',title:'Programa',detail:'Ejemplo: Todos los días a las 8:00'},
     {kind:'trigger-sun',icon:'sunset',title:'Amanecer o atardecer',detail:'Ejemplo: 10 minutos antes del atardecer'},
     {kind:'trigger-daynight',icon:'moon',title:'Día o noche',detail:'Ejemplo: Cuando está completamente oscuro'},
     {kind:'trigger-consumption',icon:'battery',title:'Consumo instantáneo',detail:'Ejemplo: El consumo instantáneo supera 500W'},
     {kind:'trigger-accessory',icon:'puzzle',title:'Accesorio',detail:'Ejemplo: Cuando se enciende una luz'},
     {kind:'trigger-module',icon:'module',title:'Módulo',detail:'Ejemplo: Cuando un módulo queda offline'},
     {kind:'trigger-nfc',icon:'nfc',title:'Etiqueta NFC',detail:'Ejemplo: Cuando detecto una etiqueta NFC'}
    ]
   },
   de:{
    actions:[
     {kind:'action-accessory',icon:'puzzle',title:'Gerät',detail:'Beispiel: Alle Lichter ausschalten'},
     {kind:'action-notification',icon:'notification',title:'Benachrichtigung',detail:'Beispiel: Eine Benachrichtigung senden'},
     {kind:'action-wait',icon:'wait',title:'Warten',detail:'Beispiel: 5 Minuten warten'},
     {kind:'action-habit',icon:'habits',title:'Routine',detail:'Beispiel: Gute Nacht starten'}
    ],
    onlyIf:[
     {kind:'query-accessory',icon:'puzzle',title:'Gerät',detail:'Beispiel: Nur wenn ein Licht eingeschaltet ist'},
     {kind:'query-consumption',icon:'battery',title:'Sofortverbrauch',detail:'Beispiel: Der Verbrauch liegt unter 500W'},
     {kind:'query-daynight',icon:'moon',title:'Tag oder Nacht',detail:'Beispiel: Nur wenn es Nacht ist'},
     {kind:'query-module',icon:'module',title:'Modul',detail:'Beispiel: Nur wenn ein Modul online ist'},
     {kind:'query-time',icon:'clock',title:'Uhrzeit',detail:'Beispiel: Zwischen 08:00 und 14:59'}
    ],
    when:[
     {kind:'trigger-schedule',icon:'clock',title:'Zeitplan',detail:'Beispiel: Jeden Tag um 8:00'},
     {kind:'trigger-sun',icon:'sunset',title:'Sonnenaufgang oder Sonnenuntergang',detail:'Beispiel: 10 Minuten vor Sonnenuntergang'},
     {kind:'trigger-daynight',icon:'moon',title:'Tag oder Nacht',detail:'Beispiel: Wenn es komplett dunkel ist'},
     {kind:'trigger-consumption',icon:'battery',title:'Sofortverbrauch',detail:'Beispiel: Der Sofortverbrauch liegt über 500W'},
     {kind:'trigger-accessory',icon:'puzzle',title:'Gerät',detail:'Beispiel: Wenn ein Licht eingeschaltet wird'},
     {kind:'trigger-module',icon:'module',title:'Modul',detail:'Beispiel: Wenn ein Modul offline geht'},
     {kind:'trigger-nfc',icon:'nfc',title:'NFC-Tag',detail:'Beispiel: Wenn ich einen NFC-Tag erkenne'}
    ]
   },
   fr:{
    actions:[
     {kind:'action-accessory',icon:'puzzle',title:'Accessoire',detail:'Exemple : éteindre toutes les lumières'},
     {kind:'action-notification',icon:'notification',title:'Notification',detail:'Exemple : envoyer une notification'},
     {kind:'action-wait',icon:'wait',title:'Attente',detail:'Exemple : attendre 5 minutes'},
     {kind:'action-habit',icon:'habits',title:'Habitude',detail:'Exemple : lancer Bonne nuit'}
    ],
    onlyIf:[
     {kind:'query-accessory',icon:'puzzle',title:'Accessoire',detail:'Exemple : seulement si une lumière est allumée'},
     {kind:'query-consumption',icon:'battery',title:'Consommation instantanée',detail:'Exemple : la consommation est inférieure à 500W'},
     {kind:'query-daynight',icon:'moon',title:'Jour ou nuit',detail:'Exemple : seulement s’il fait nuit'},
     {kind:'query-module',icon:'module',title:'Module',detail:'Exemple : seulement si un module est en ligne'},
     {kind:'query-time',icon:'clock',title:'Horaire',detail:'Exemple : entre 08:00 et 14:59'}
    ],
    when:[
     {kind:'trigger-schedule',icon:'clock',title:'Programme',detail:'Exemple : tous les jours à 8:00'},
     {kind:'trigger-sun',icon:'sunset',title:'Lever ou coucher du soleil',detail:'Exemple : 10 minutes avant le coucher du soleil'},
     {kind:'trigger-daynight',icon:'moon',title:'Jour ou nuit',detail:'Exemple : quand il fait complètement noir'},
     {kind:'trigger-consumption',icon:'battery',title:'Consommation instantanée',detail:'Exemple : la consommation instantanée dépasse 500W'},
     {kind:'trigger-accessory',icon:'puzzle',title:'Accessoire',detail:'Exemple : quand une lumière s’allume'},
     {kind:'trigger-module',icon:'module',title:'Module',detail:'Exemple : quand un module passe hors ligne'},
     {kind:'trigger-nfc',icon:'nfc',title:'Tag NFC',detail:'Exemple : quand je détecte un tag NFC'}
    ]
   }
  };
  return (groups[this.locale]||groups.it)[target]||[];
 }
 localizedLabels(){
  const map={
   it:{value:'Valore',nextSunrise:'Prossima Alba: 07:23',nextSunset:'Prossimo Tramonto: 20:51',delay:'Anticipa o ritarda',lessThan:'Minore di',greaterThan:'Maggiore di',threshold:'Soglia in W',from:'Dalle',to:'Alle',notificationTitle:'Inserisci titolo notifica',notificationMessage:'Inserisci messaggio notifica',notificationTitleValue:'Avviso Freedompro',notificationMessageValue:'La tua Abitudine è stata eseguita.',hours:'Ore',minutes:'Minuti',simulateScan:'In questa demo la scansione viene simulata',allDays:'Tutti i giorni',minutesSuffix:'minuti',between:'Tra le',and:'e',inactive:'Non attiva',ready:'Pronta',running:'In esecuzione',renameHome:'Rinomina casa',enterNewHomeName:'Inserisci il nuovo nome.',homeName:'Nome casa',deleteHome:'Elimina casa',demoNoDelete:'La demo non elimina realmente alcuna casa.',removeModule:'Rimuovi Modulo',deleteRoomTitle:'Elimina stanza',deleteRoomText:'Vuoi eliminare',sunrise:'Alba',sunset:'Tramonto',day:'È giorno',night:'È notte',before:'Prima',start:'Avvia',stop:'Arresta',stateChanged:'Cambio di stato',turnsOn:'Si accende',turnsOff:'Si spegne',ifOnline:'Se è online',ifOffline:'Se è offline',goesOnline:'Va online',goesOffline:'Va offline',turnOn:'Accendi',turnOff:'Spegni',open:'Apri',close:'Chiudi',ifOn:'Se è acceso',ifOff:'Se è spento',assignedTo:'Assegnato a',item:'Elemento'},
   en:{value:'Value',nextSunrise:'Next sunrise: 07:23',nextSunset:'Next sunset: 20:51',delay:'Advance or delay',lessThan:'Less than',greaterThan:'Greater than',threshold:'Threshold in W',from:'From',to:'To',notificationTitle:'Enter notification title',notificationMessage:'Enter notification message',notificationTitleValue:'Freedompro alert',notificationMessageValue:'Your Habit has been executed.',hours:'Hours',minutes:'Minutes',simulateScan:'In this demo, scanning is simulated',allDays:'Every day',minutesSuffix:'minutes',between:'Between',and:'and',inactive:'Inactive',ready:'Ready',running:'Running',renameHome:'Rename home',enterNewHomeName:'Enter the new name.',homeName:'Home name',deleteHome:'Delete home',demoNoDelete:'The demo does not actually delete any home.',removeModule:'Remove Module',deleteRoomTitle:'Delete room',deleteRoomText:'Do you want to delete',sunrise:'Sunrise',sunset:'Sunset',day:'It is day',night:'It is night',before:'Before',start:'Start',stop:'Stop',stateChanged:'State change',turnsOn:'Turns on',turnsOff:'Turns off',ifOnline:'If online',ifOffline:'If offline',goesOnline:'Goes online',goesOffline:'Goes offline',turnOn:'Turn on',turnOff:'Turn off',open:'Open',close:'Close',ifOn:'If on',ifOff:'If off',assignedTo:'Assigned to',item:'Item'},
   es:{value:'Valor',nextSunrise:'Próximo amanecer: 07:23',nextSunset:'Próximo atardecer: 20:51',delay:'Adelanta o retrasa',lessThan:'Menor que',greaterThan:'Mayor que',threshold:'Umbral en W',from:'Desde',to:'Hasta',notificationTitle:'Introduce el título de la notificación',notificationMessage:'Introduce el mensaje de la notificación',notificationTitleValue:'Aviso Freedompro',notificationMessageValue:'Tu rutina se ha ejecutado.',hours:'Horas',minutes:'Minutos',simulateScan:'En esta demo, el escaneo está simulado',allDays:'Todos los días',minutesSuffix:'minutos',between:'Entre las',and:'y las',inactive:'Inactiva',ready:'Lista',running:'En ejecución',renameHome:'Renombrar casa',enterNewHomeName:'Introduce el nuevo nombre.',homeName:'Nombre de la casa',deleteHome:'Eliminar casa',demoNoDelete:'La demo no elimina realmente ninguna casa.',removeModule:'Eliminar módulo',deleteRoomTitle:'Eliminar estancia',deleteRoomText:'¿Quieres eliminar',sunrise:'Amanecer',sunset:'Atardecer',day:'Es de día',night:'Es de noche',before:'Antes',start:'Iniciar',stop:'Detener',stateChanged:'Cambio de estado',turnsOn:'Se enciende',turnsOff:'Se apaga',ifOnline:'Si está online',ifOffline:'Si está offline',goesOnline:'Pasa a online',goesOffline:'Pasa a offline',turnOn:'Encender',turnOff:'Apagar',open:'Abrir',close:'Cerrar',ifOn:'Si está encendido',ifOff:'Si está apagado',assignedTo:'Asignado a',item:'Elemento'},
   de:{value:'Wert',nextSunrise:'Nächster Sonnenaufgang: 07:23',nextSunset:'Nächster Sonnenuntergang: 20:51',delay:'Vorziehen oder verzögern',lessThan:'Kleiner als',greaterThan:'Größer als',threshold:'Schwelle in W',from:'Von',to:'Bis',notificationTitle:'Benachrichtigungstitel eingeben',notificationMessage:'Benachrichtigungstext eingeben',notificationTitleValue:'Freedompro Hinweis',notificationMessageValue:'Deine Routine wurde ausgeführt.',hours:'Stunden',minutes:'Minuten',simulateScan:'In dieser Demo wird das Scannen simuliert',allDays:'Jeden Tag',minutesSuffix:'Minuten',between:'Zwischen',and:'und',inactive:'Inaktiv',ready:'Bereit',running:'Wird ausgeführt',renameHome:'Zuhause umbenennen',enterNewHomeName:'Gib den neuen Namen ein.',homeName:'Name des Zuhauses',deleteHome:'Zuhause löschen',demoNoDelete:'Die Demo löscht kein Zuhause wirklich.',removeModule:'Modul entfernen',deleteRoomTitle:'Raum löschen',deleteRoomText:'Möchtest du',sunrise:'Sonnenaufgang',sunset:'Sonnenuntergang',day:'Es ist Tag',night:'Es ist Nacht',before:'Vor',start:'Starten',stop:'Stoppen',stateChanged:'Statusänderung',turnsOn:'Schaltet ein',turnsOff:'Schaltet aus',ifOnline:'Wenn online',ifOffline:'Wenn offline',goesOnline:'Geht online',goesOffline:'Geht offline',turnOn:'Einschalten',turnOff:'Ausschalten',open:'Öffnen',close:'Schließen',ifOn:'Wenn eingeschaltet',ifOff:'Wenn ausgeschaltet',assignedTo:'Zugewiesen an',item:'Element'},
   fr:{value:'Valeur',nextSunrise:'Prochain lever du soleil : 07:23',nextSunset:'Prochain coucher du soleil : 20:51',delay:'Avancer ou retarder',lessThan:'Inférieur à',greaterThan:'Supérieur à',threshold:'Seuil en W',from:'De',to:'À',notificationTitle:'Saisir le titre de la notification',notificationMessage:'Saisir le message de la notification',notificationTitleValue:'Alerte Freedompro',notificationMessageValue:'Votre habitude a été exécutée.',hours:'Heures',minutes:'Minutes',simulateScan:'Dans cette démo, le scan est simulé',allDays:'Tous les jours',minutesSuffix:'minutes',between:'Entre',and:'et',inactive:'Inactive',ready:'Prête',running:'En cours',renameHome:'Renommer la maison',enterNewHomeName:'Saisissez le nouveau nom.',homeName:'Nom de la maison',deleteHome:'Supprimer la maison',demoNoDelete:'La démo ne supprime réellement aucune maison.',removeModule:'Supprimer le module',deleteRoomTitle:'Supprimer la pièce',deleteRoomText:'Voulez-vous supprimer',sunrise:'Lever du soleil',sunset:'Coucher du soleil',day:'Il fait jour',night:'Il fait nuit',before:'Avant',start:'Lancer',stop:'Arrêter',stateChanged:'Changement d’état',turnsOn:'S’allume',turnsOff:'S’éteint',ifOnline:'Si en ligne',ifOffline:'Si hors ligne',goesOnline:'Passe en ligne',goesOffline:'Passe hors ligne',turnOn:'Allumer',turnOff:'Éteindre',open:'Ouvrir',close:'Fermer',ifOn:'Si allumé',ifOff:'Si éteint',assignedTo:'Attribué à',item:'Élément'}
  };
  return map[this.locale]||map.it;
 }
 habitCountSummary(whenCount,actionCount){
  if(this.locale==='en')return `${whenCount} conditions · ${actionCount} events`;
  if(this.locale==='es')return `${whenCount} condiciones · ${actionCount} eventos`;
  if(this.locale==='de')return `${whenCount} Bedingungen · ${actionCount} Ereignisse`;
  if(this.locale==='fr')return `${whenCount} conditions · ${actionCount} événements`;
  return `${whenCount} condizioni · ${actionCount} eventi`;
 }
 deviceStateLabel(d){
  if(d.type==='shutter')return `${Math.round(d.position)}%`;
  return d.on?this.copy.ui.states.on:this.copy.ui.states.off;
 }
 isTruthyActionState(value){
  const labels=this.localizedLabels();
  return value===labels.turnOn||value===labels.open||value===labels.start;
 }
 isStandaloneMode(){
  if(typeof window==='undefined')return false;
  return new URLSearchParams(window.location.search).get('app-demo')==='1';
 }
 isMobileViewport(){
  return typeof window!=='undefined'&&window.matchMedia('(max-width: 840px)').matches;
 }
 isMobilePreviewMode(){
  return this.isMobileViewport()&&!this.isStandaloneMode();
 }
 launchDemoUrl(){
  if(typeof window==='undefined')return '#';
  const url=new URL(window.location.href);
  url.searchParams.set('app-demo','1');
  return url.toString();
 }
 connectedCallback(){
  if(this.ready){
   this.updateStatusTime();
   if(!this.statusTimeTimer)this.statusTimeTimer=setInterval(()=>this.updateStatusTime(),60000);
   return;
  }
  this.locale=resolveDemoLocale(this.resolveLocale());
  this.copy=getDemoCopy(this.locale);
  this.flow=getFlowCopy(this.locale);
  this.s=buildDemoState(this.locale);
  this.ready=true;
  const standalone=this.isStandaloneMode();
  const mobilePreview=this.isMobilePreviewMode();
  const mobileCtaLabel=this.getAttribute('mobile-cta-label')||this.copy.ui.mobileCtaLabel;
  const hintTitle=this.getAttribute('hint-title')||this.copy.ui.hintTitle;
  const hintText=this.getAttribute('hint-text')||this.copy.ui.hintText;
  this.shadowRoot.innerHTML=`
   <link rel="stylesheet" href="${this.getAttribute('css-url')||'assets/fp-home-demo.css'}">
   <section class="fp-site ${standalone?'is-standalone':''} ${mobilePreview?'is-mobile-preview':''}">
    <div class="fp-copy">
     <h1 class="h1">${E(this.getAttribute('heading')||this.copy.ui.defaultHeading)}</h1>
     <p>${E(this.getAttribute('subheading')||this.copy.ui.defaultSubheading)}</p>
     <div class="fp-store-badges">
      <a href="https://apps.apple.com/it/app/freedompro-home/id1598082027" class="fp-store-badge" aria-label="${E(this.copy.ui.appStoreAria)}" target="_blank" rel="noopener noreferrer">
       <img src="https://cdn.shopify.com/s/files/1/0907/1398/1312/files/app_store_430x.png?v=1744987130#" alt="${E(this.copy.ui.appStoreAlt)}" loading="eager" fetchpriority="high">
      </a>
      <a href="https://play.google.com/store/apps/details?id=eu.freedompro.app&hl=it" class="fp-store-badge" aria-label="${E(this.copy.ui.playStoreAria)}" target="_blank" rel="noopener noreferrer">
       <img src="https://cdn.shopify.com/s/files/1/0907/1398/1312/files/google_play_store_430x.png?v=1744987043#" alt="${E(this.copy.ui.playStoreAlt)}" loading="eager" fetchpriority="high">
      </a>
     </div>
     <div class="fp-demo-hint" aria-label="${E(hintTitle)}">
      <span class="material-symbols-outlined fp-demo-hint-icon" aria-hidden="true">touch_app</span>
      <span class="fp-demo-hint-copy">
       <strong>${E(hintTitle)}</strong>
       <small>${E(hintText)}</small>
      </span>
     </div>
    </div>
    <div class="fp-stage">
     <div class="fp-phone" data-phone tabindex="-1">
      <div class="fp-statusbar">
       <span class="fp-status-time" data-role="status-time">--:--</span>
       <span class="fp-demo-island" aria-label="${E(this.copy.ui.liveDemo)}">
        <span class="fp-demo-dot"></span>
        <span>${E(this.copy.ui.liveDemo)}</span>
       </span>
       <span class="fp-status-icons"><span class="fp-battery"></span></span>
      </div>
      <div class="fp-app-shell" data-shell>
       <div class="fp-base-page" data-base></div>
       <div data-routes></div>
      </div>
      <div data-overlay></div>
      <div class="fp-toast" data-toast></div>
     </div>
     ${mobilePreview?`<a class="fp-mobile-open-demo" href="${E(this.launchDemoUrl())}" target="_blank" rel="noopener noreferrer"><span class="material-symbols-outlined" aria-hidden="true">touch_app</span><span>${E(mobileCtaLabel)}</span></a>`:''}
    </div>
   </section>`;
  this.shadowRoot.addEventListener('click',e=>this.click(e));
  this.shadowRoot.addEventListener('input',e=>this.input(e));
  this.shadowRoot.addEventListener('change',e=>this.input(e));
  this.shadowRoot.addEventListener('pointerdown',e=>this.pointerDown(e));
  this.shadowRoot.addEventListener('pointermove',e=>this.pointerMove(e));
  this.shadowRoot.addEventListener('pointerup',e=>this.pointerUp(e));
  this.shadowRoot.addEventListener('pointercancel',e=>this.pointerUp(e));
  this.updateStatusTime();
  this.statusTimeTimer=setInterval(()=>this.updateStatusTime(),60000);
  this.renderBase();
 }
 disconnectedCallback(){
  clearInterval(this.shutterTimer);
  clearInterval(this.statusTimeTimer);
  clearTimeout(this.longTimer);
 }
 device(id){return this.s.devices[id]}
 roomByName(name){return this.s.rooms.find(r=>r.name===name)}
 summary(){
  const d=Object.values(this.s.devices);
  return{
   lights:d.filter(x=>x.type==='light'&&x.on).length,
   shutters:d.filter(x=>x.type==='shutter'&&x.position>0).length,
   outlets:d.filter(x=>x.type==='outlet'&&x.on).length
  };
 }
 currentRoute(){return this.routes[this.routes.length-1]||null}
 updateStatusTime(){
  const timeNode=this.shadowRoot.querySelector('[data-role="status-time"]');
  if(!timeNode)return;
  const now=new Date();
  const text=now.toLocaleTimeString(this.copy.timeLocale,{hour:'2-digit',minute:'2-digit'});
  timeNode.textContent=text;
 }
 renderBase(){
  const base=this.shadowRoot.querySelector('[data-base]');
  base.innerHTML=`${this.baseAppbar()}<div class="fp-page-content" data-base-content>${this.baseContent()}</div>${this.bottomNav()}`;
 }
 refreshBase(){
  const base=this.shadowRoot.querySelector('[data-base]');
  if(!base)return;
  const content=base.querySelector('[data-base-content]');
  if(content)content.innerHTML=this.baseContent();
  const nav=base.querySelector('.fp-bottom-nav');
  if(nav)nav.outerHTML=this.bottomNav();
  const appbar=base.querySelector('.fp-appbar');
  if(appbar)appbar.outerHTML=this.baseAppbar();
 }
 baseAppbar(){
  return`<header class="fp-appbar">
   <button class="fp-home-title" data-action="home-menu"><span class="fp-more-circle">${appbarIcon('menuCircle')}</span><span>${E(this.s.home.name)}</span></button>
   <button class="fp-add" data-action="plus-menu">${I('plus')}<span class="fp-add-badge"></span></button>
  </header>`;
 }
 bottomNav(){
  return`<nav class="fp-bottom-nav">${[
   ['home','home',this.copy.ui.nav.home],['accessories','accessories',this.copy.ui.nav.accessories],['habits','habits',this.copy.ui.nav.habits],['consumption','chart',this.copy.ui.nav.consumption]
  ].map(([t,ic,l])=>`<button class="${this.s.tab===t?'active':''}" data-action="tab" data-tab="${t}">${navIcon(ic,l)}<span>${l}</span></button>`).join('')}</nav>`;
 }
 baseContent(){
  if(this.s.tab==='accessories')return this.accessoriesScreen();
  if(this.s.tab==='habits')return this.habitsScreen();
  if(this.s.tab==='consumption')return this.consumptionScreen();
  return this.homeScreen();
 }

 homeScreen(){
  const s=this.summary();
 return`<section class="fp-screen">
   <div class="fp-summary-scroll">
    <button class="fp-summary-chip light ${s.lights>0?'is-active':''}" data-summary-kind="light" data-action="summary" data-value="light">${summaryIcon('light')}<span data-summary-label>${this.summaryText('light',s.lights)}</span></button>
    <button class="fp-summary-chip shutter ${s.shutters>0?'is-active':''}" data-summary-kind="shutter" data-action="summary" data-value="shutter">${summaryIcon('shutter')}<span data-summary-label>${this.summaryText('shutter',s.shutters)}</span></button>
    <button class="fp-summary-chip outlet ${s.outlets>0?'is-active':''}" data-summary-kind="outlet" data-action="summary" data-value="outlet">${summaryIcon('outlet')}<span data-summary-label>${this.summaryText('outlet',s.outlets)}</span></button>
   </div>
   <div class="fp-section-title"><h3>${this.copy.ui.home.dashboard}</h3><button class="fp-personalize" data-action="dashboard-edit">${I('editGrid')}${this.copy.ui.home.personalize}</button></div>
   <div class="fp-grid">${this.s.dashboard.map(item=>this.dashboardTile(item)).join('')}</div>
  </section>`;
 }
 dashboardTile(item,editing=false){
  if(item.kind==='room'){
   const r=this.s.rooms.find(x=>x.id===item.ref);
   return`<article class="fp-tile ${editing?'editing':''}" data-longpress="room" data-id="${r.id}">
    ${editing?`<button class="fp-edit-remove" data-action="dashboard-remove" data-id="${item.id}">−</button>`:''}
    <div class="fp-tile-main" data-action="${editing?'noop':'open-room'}" data-id="${r.id}">
     <span class="fp-entity-icon room">${I('room')}</span>
     <span class="fp-entity-copy"><strong>${E(r.name)}</strong><small>${this.roomAccessoryText(Object.values(this.s.devices).filter(d=>d.room===r.name).length)}</small></span>
    </div>
   </article>`;
  }
  if(item.kind==='habit'){
   const h=this.s.habits.find(x=>x.id===item.ref);
   if(!h)return'';
   return`<article class="fp-tile wide habit ${editing?'editing':''}" data-longpress="habit" data-id="${h.id}" data-habit-id="${h.id}">
    ${editing?`<button class="fp-edit-remove" data-action="dashboard-remove" data-id="${item.id}">−</button>`:''}
    <div class="fp-tile-main" data-action="${editing?'noop':'habit-open'}" data-id="${h.id}">
     <button class="fp-entity-icon habit ${h.active?'on':''}" data-action="${editing?'noop':'habit-run'}" data-id="${h.id}">${habitIcon()}</button>
     <span class="fp-entity-copy"><strong>${E(h.name)}</strong><small>${h.disabled?this.copy.ui.states.inactive:this.copy.ui.states.active}</small></span>
     <button class="fp-habit-play" data-action="${editing?'noop':'habit-run'}" data-id="${h.id}">${F('play_arrow')}</button>
   </div>
   </article>`;
  }
  const d=this.device(item.ref);
  if(!d)return'';
  if(d.id==='presaTV')return this.presaTvTile(d,item.id,editing);
  const wide=d.type==='shutter';
  const on=d.type==='shutter'?d.position>0:d.on;
  return`<article class="fp-tile ${wide?'wide':''} ${editing?'editing':''}" data-longpress="device" data-id="${d.id}" data-device-id="${d.id}">
   ${editing?`<button class="fp-edit-remove" data-action="dashboard-remove" data-id="${item.id}">−</button>`:''}
   <div class="fp-tile-main" data-action="${editing?'noop':'device-open'}" data-id="${d.id}">
    <button class="fp-entity-icon ${d.type} ${on?'on':''}" data-action="${editing?'noop':(['light','outlet','switch'].includes(d.type)?'device-toggle':'device-open')}" data-id="${d.id}">${entityIcon(d.type)}</button>
    <span class="fp-entity-copy"><strong>${E(d.name)}</strong><small>${E(d.room)}</small></span>
    ${d.type==='shutter'?`<span class="fp-shutter-controls">
     <button data-action="shutter" data-id="${d.id}" data-value="100">${I('up')}</button>
     <button data-action="shutter-stop" data-id="${d.id}">${F('stop')}</button>
     <button data-action="shutter" data-id="${d.id}" data-value="0">${I('down')}</button>
    </span>`:''}
   </div>
   ${['light','outlet'].includes(d.type)?`<span class="fp-watt" data-device-watt="${d.id}" ${d.on?'':'hidden'}>${d.watt}W</span>`:''}
   ${d.type==='shutter'?`<span class="fp-percent">${Math.round(d.position)}%</span>`:''}
  </article>`;
 }
 presaTvTile(d,itemId,editing=false){
  const on=Boolean(d.on);
  return`<article class="fp-tile wide outlet-tv ${on?'on':'off'} ${editing?'editing':''}" data-action="${editing?'noop':'device-open'}" data-id="${d.id}" data-device-id="${d.id}">
   ${editing?`<button class="fp-edit-remove" data-action="dashboard-remove" data-id="${itemId}">−</button>`:''}
   <div class="fp-tile-main fp-tv-main" data-action="${editing?'noop':'device-open'}" data-id="${d.id}">
    <div class="fp-tv-left">
     <div class="fp-tv-info">
      <div class="fp-tv-head">
       <button class="fp-entity-icon outlet ${on?'on':''}" data-action="${editing?'noop':'device-toggle'}" data-id="${d.id}" aria-label="${on?this.copy.ui.states.off:this.copy.ui.states.on} ${E(d.name)}">${entityIcon(d.type)}</button>
       <span class="fp-tv-copy"><strong>${E(d.name)}</strong><small>${E(d.room)}</small></span>
       <span class="fp-watt fp-tv-watt" data-device-watt="${d.id}" ${d.on?'':'hidden'}>${d.watt}W</span>
      </div>
     </div>
     <button class="fp-tv-toggle ${on?'on':'off'}" data-action="${editing?'noop':'device-toggle'}" data-id="${d.id}" aria-label="${on?this.copy.ui.states.off:this.copy.ui.states.on} ${E(d.name)}" aria-pressed="${on}">${I('power')}</button>
    </div>
    <div class="fp-tv-chart" aria-hidden="true">${tvSparkline()}${tvAxis()}</div>
   </div>
  </article>`;
 }
 accessoriesScreen(){
  const typeLabels={all:this.copy.ui.accessories.type,light:this.copy.ui.accessories.types.light,shutter:this.copy.ui.accessories.types.shutter,outlet:this.copy.ui.accessories.types.outlet,switch:this.copy.ui.accessories.types.switch};
  const roomOptions=[{value:'all',label:this.copy.ui.accessories.roomAll},...this.s.rooms.map(r=>({value:r.name,label:r.name}))];
  const typeOptions=[
   {value:'all',label:this.copy.ui.accessories.typeAll},
   ...Object.entries(typeLabels).filter(([value])=>value!=='all').map(([value,label])=>({value,label}))
  ];
  const query=this.s.accessoryQuery.trim().toLowerCase();
  const list=Object.values(this.s.devices).filter(d=>{
   const byRoom=this.s.accessoryRoom==='all'||d.room===this.s.accessoryRoom;
   const byType=this.s.accessoryType==='all'||d.type===this.s.accessoryType;
   if(!byRoom)return false;
   if(!byType)return false;
   if(!query)return true;
   return [d.name,d.room,d.module,d.type].some(v=>String(v||'').toLowerCase().includes(query));
  });
  return`<section class="fp-screen fp-home-screen">
   <div class="fp-accessories-head">
    <label class="fp-accessory-search">
     <span class="fp-accessory-search-icon" aria-hidden="true">${I('search')}</span>
     <input type="search" data-field="accessory-search" value="${E(this.s.accessoryQuery)}" placeholder="${E(this.copy.ui.accessories.searchPlaceholder)}">
    </label>
    <div class="fp-accessory-dropdowns">
     <div class="fp-accessory-dropdown-wrap ${this.s.accessoryDropdown==='room'?'is-open':''}">
      <button class="fp-accessory-dropdown ${this.s.accessoryRoom!=='all'?'is-active':''}" type="button" data-action="accessory-dropdown-toggle" data-value="room" aria-expanded="${this.s.accessoryDropdown==='room'}">
       <span class="fp-accessory-dropdown-main">
        <span class="material-symbols-outlined fp-accessory-dropdown-icon fp-accessory-dropdown-icon-symbol" aria-hidden="true">nest_multi_room</span>
        <span>${E(this.s.accessoryRoom==='all'?this.copy.ui.accessories.rooms:(roomOptions.find(o=>o.value===this.s.accessoryRoom)?.label||this.copy.ui.accessories.rooms))}</span>
       </span>
       <span class="fp-accessory-dropdown-chevron" aria-hidden="true">${I('expandMore')}</span>
      </button>
      ${this.s.accessoryDropdown==='room'?`<div class="fp-accessory-menu">${roomOptions.map(o=>`<button class="fp-accessory-menu-item ${this.s.accessoryRoom===o.value?'is-selected':''}" type="button" data-action="accessory-dropdown-select" data-kind="room" data-value="${E(o.value)}">${E(o.label)}</button>`).join('')}</div>`:''}
     </div>
     <div class="fp-accessory-dropdown-wrap ${this.s.accessoryDropdown==='type'?'is-open':''}">
      <button class="fp-accessory-dropdown ${this.s.accessoryType!=='all'?'is-active':''}" type="button" data-action="accessory-dropdown-toggle" data-value="type" aria-expanded="${this.s.accessoryDropdown==='type'}">
       <span class="fp-accessory-dropdown-main">
        <span class="material-symbols-outlined fp-accessory-dropdown-icon fp-accessory-dropdown-icon-symbol" aria-hidden="true">sell</span>
        <span>${E(this.s.accessoryType==='all'?this.copy.ui.accessories.type:(typeLabels[this.s.accessoryType]||this.copy.ui.accessories.type))}</span>
       </span>
       <span class="fp-accessory-dropdown-chevron" aria-hidden="true">${I('expandMore')}</span>
      </button>
      ${this.s.accessoryDropdown==='type'?`<div class="fp-accessory-menu">${typeOptions.map(o=>`<button class="fp-accessory-menu-item ${this.s.accessoryType===o.value?'is-selected':''}" type="button" data-action="accessory-dropdown-select" data-kind="type" data-value="${E(o.value)}">${E(o.label)}</button>`).join('')}</div>`:''}
     </div>
    </div>
   </div>
   <div class="fp-accessory-list">${list.length?list.map(d=>{
    const on=d.type==='shutter'?d.position>0:d.on;
    return`<button class="fp-accessory-row" data-action="device-open" data-id="${d.id}" data-device-id="${d.id}" data-longpress="device" data-id="${d.id}">
     <span class="fp-entity-icon ${d.type} ${on?'on':''}">${entityIcon(d.type)}</span>
     <span><strong>${E(d.name)}</strong><small>${E(d.room)} · ${E(d.module)}</small></span>
    </button>`;
   }).join(''):`<div class="fp-empty" style="min-height:280px"><h3>${this.copy.ui.accessories.emptyTitle}</h3><p>${this.copy.ui.accessories.emptyText}</p></div>`}</div>
  </section>`;
 }
 habitsIllustration(){
  return`<svg viewBox="0 0 220 145" aria-hidden="true">
   <path d="M28 108h160v19H28z" fill="#b9cef8" stroke="none"/>
   <path d="M51 72h113a24 24 0 0 1 24 24v12H28V95a23 23 0 0 1 23-23Z" fill="#dbe6fb" stroke="none"/>
   <path d="M46 103V72m122 31V72" stroke="#8baeea" stroke-width="6"/>
   <circle cx="102" cy="48" r="13" fill="#ffc01b" stroke="none"/>
   <path d="M99 62c-17 4-23 15-24 31m29-30 17 18 16-10m-37-6 8 34" stroke="#2377d4" stroke-width="8" fill="none" stroke-linecap="round"/>
   <path d="m111 100 14 21m-21-19-13 21" stroke="#2377d4" stroke-width="8" stroke-linecap="round"/>
   <path d="M18 127h182" stroke="#8aa8dc" stroke-width="5" stroke-linecap="round"/>
  </svg>`;
 }
 habitsScreen(){
  if(!this.s.habits.length)return`<section class="fp-screen">
   <div class="fp-empty">${this.habitsIllustration()}<h3>${this.copy.ui.habits.emptyTitle}</h3><p>${this.copy.ui.habits.emptyText}</p></div>
  </section>`;
  const cards=this.s.habits.map(h=>`<div class="fp-habit-card" data-action="habit-open" data-id="${h.id}" data-longpress="habit">
    <span class="fp-entity-icon habit ${h.active?'on':''}">${habitIcon()}</span>
    <span><strong>${E(h.name)}</strong><small>${h.disabled?this.copy.ui.states.inactive:E(h.summary)}</small></span>
    <button class="fp-habit-play ${h.active?'on':'off'}" data-action="habit-run" data-id="${h.id}">${F(h.active?'pause':'play_arrow')}</button>
   </div>`);
  const intro=cards.slice(0,2).join('');
  const rest=cards.slice(2).join('');
 return`<section class="fp-screen">
   <div class="fp-habit-list">
   ${intro}
    <button class="fp-habit-promo" type="button" data-action="habit-create-open">
     <span class="fp-habit-promo-copy">
      <strong>${this.copy.ui.habits.promoTitle}</strong>
      <small>${this.copy.ui.habits.promoText}</small>
     </span>
     <span class="fp-habit-promo-arrow" aria-hidden="true">${I('chevron')}</span>
    </button>
    ${rest}
   </div>
  </section>`;
 }
 chartData(){
  const base={
   day:[8,15,11,18,20,26,22,34,29,37,44,38,48,42,51,57,49,43,36,32,26,21,17,12],
   week:[48,63,58,72,67,82,61],
   month:[54,100,72,73,41,67,18,21,43,53,69,42,35,46,32,58,20],
   year:[40,46,50,58,66,78,74,69,61,54,49,43]
  }[this.s.period];
  const factor={all:1,light:.62,shutter:.18,outlet:.8}[this.s.category];
  return base.map((v,i)=>Math.max(5,v*factor*(1+Math.sin(i+this.s.dateOffset)*.035)));
 }
 consumptionScreen(){
  const data=this.chartData();
  const labels=this.copy.ui.consumption.periods;
  const totals={day:'0,842',week:'5,936',month:'17,373',year:'186,520'};
  const color={all:'#2377d4',light:'#ffc01b',shutter:'#4791eb',outlet:'#58c47d'}[this.s.category];
  const categoryLabels={all:this.copy.ui.consumption.category,light:this.copy.ui.consumption.categories.light,shutter:this.copy.ui.consumption.categories.shutter,outlet:this.copy.ui.consumption.categories.outlet};
  const categoryOptions=[
   {value:'all',label:this.copy.ui.consumption.categoryAll},
   {value:'light',label:this.copy.ui.consumption.categories.light},
   {value:'shutter',label:this.copy.ui.consumption.categories.shutter},
   {value:'outlet',label:this.copy.ui.consumption.categories.outlet}
  ];
  const categoryFilter=`<div class="fp-consumption-filter">
    <div class="fp-accessory-dropdown-wrap ${this.s.consumptionDropdown==='category'?'is-open':''}">
     <button class="fp-accessory-dropdown ${this.s.category!=='all'?'is-active':''}" type="button" data-action="consumption-dropdown-toggle" data-value="category" aria-expanded="${this.s.consumptionDropdown==='category'}">
      <span class="fp-accessory-dropdown-main">
       <span class="material-symbols-outlined fp-accessory-dropdown-icon fp-accessory-dropdown-icon-symbol" aria-hidden="true">sell</span>
       <span>${E(this.s.category==='all'?this.copy.ui.consumption.category:(categoryLabels[this.s.category]||this.copy.ui.consumption.category))}</span>
      </span>
      <span class="fp-accessory-dropdown-chevron" aria-hidden="true">${I('expandMore')}</span>
     </button>
     ${this.s.consumptionDropdown==='category'?`<div class="fp-accessory-menu">${categoryOptions.map(o=>`<button class="fp-accessory-menu-item ${this.s.category===o.value?'is-selected':''}" type="button" data-action="consumption-dropdown-select" data-value="${o.value}">${o.label}</button>`).join('')}</div>`:''}
    </div>
   </div>`;
  return`<section class="fp-screen">
   <div class="fp-segment">${[['day',this.copy.ui.consumption.segments.day],['week',this.copy.ui.consumption.segments.week],['month',this.copy.ui.consumption.segments.month],['year',this.copy.ui.consumption.segments.year]].map(([v,l])=>`<button class="${this.s.period===v?'active':''}" data-action="period" data-value="${v}">${l}</button>`).join('')}</div>
   <article class="fp-chart-card">
    <div class="fp-chart-title"><button data-action="date-prev">‹</button><span><h4>${labels[this.s.period]}</h4><p>${this.copy.ui.consumption.totalPrefix} ${totals[this.s.period]} kWh</p></span><button data-action="date-next">›</button></div>
    ${categoryFilter}
    <div class="fp-chart-area">
     ${[0,25,50,75,100].map((v,i)=>`<span class="fp-grid-line" style="top:${v}%"></span><span class="fp-grid-label" style="top:${v}%">${(2-(i*.5)).toFixed(3).replace('.',',')}</span>`).join('')}
     <div class="fp-bars">${data.map(v=>`<i style="height:${v}%;background:${color}"></i>`).join('')}</div>
     <div class="fp-axis"><span>1</span><span>5</span><span>10</span><span>15</span><span>20</span><span>25</span><span>30</span></div>
    </div>
   </article>
  </section>`;
 }
 push(route,params={}){
  const host=this.shadowRoot.querySelector('[data-routes]');
  const base=this.shadowRoot.querySelector('[data-base]');
  const page=document.createElement('section');
  page.className='fp-route-page is-entering';
  page.dataset.route=route;
  const entry={route,params,page};
  this.routes.push(entry);
  page.innerHTML=this.routeHtml(entry);
  host.appendChild(page);
  base.classList.add('is-under');
  requestAnimationFrame(()=>requestAnimationFrame(()=>{page.classList.remove('is-entering');page.classList.add('is-active')}));
 }
 pop(){
  const entry=this.currentRoute();
  if(!entry)return;
  entry.page.classList.remove('is-active');
  entry.page.classList.add('is-leaving');
  setTimeout(()=>{
   entry.page.remove();
   this.routes.pop();
   if(!this.routes.length)this.shadowRoot.querySelector('[data-base]').classList.remove('is-under');
   else this.currentRoute().page.classList.add('is-active');
  },280);
 }
 popTo(route){
  const targetIndex=this.routes.map(r=>r.route).lastIndexOf(route);
  if(targetIndex<0)return;
  const current=this.currentRoute();
  current.page.classList.remove('is-active');
  current.page.classList.add('is-leaving');
  setTimeout(()=>{
   while(this.routes.length-1>targetIndex){this.routes.pop().page.remove()}
   this.routes[targetIndex].page.classList.remove('is-leaving');
   this.routes[targetIndex].page.classList.add('is-active');
  },280);
 }
 closeAllRoutes(){
  this.routes.forEach(r=>r.page.remove());
  this.routes=[];
  this.shadowRoot.querySelector('[data-base]').classList.remove('is-under');
 }
 refreshRoute(){
  const r=this.currentRoute();
  if(r)r.page.innerHTML=this.routeHtml(r);
 }
 routeHtml(entry){
  const title=this.routeTitle(entry);
  const right=this.routeRight(entry);
  if(entry.route==='habit-config'){
   return`<header class="fp-appbar route fp-appbar-habit-config"><button class="fp-action-text cancel" data-action="back">${this.copy.ui.common.cancel}</button><h3>${E(title)}</h3><button class="fp-action-text confirm" data-action="habit-config-confirm" data-target="${entry.params.target}" data-kind="${entry.params.kind}">${this.copy.ui.common.confirm}</button></header><div class="fp-page-content">${this.routeContent(entry)}</div>`;
  }
  return`<header class="fp-appbar route"><button class="fp-back" data-action="back">${I('back')}</button><h3>${E(title)}</h3>${right}</header><div class="fp-page-content">${this.routeContent(entry)}</div>`;
 }
 routeTitle(e){
  if(e.route==='habit-config'&&e.params.kind==='trigger-sun')return this.copy.ui.common.sunriseSunset;
  const map={
   'manage-home':this.copy.ui.routeTitles.manageHome,'rooms':this.copy.ui.routeTitles.rooms,'room-add':this.copy.ui.routeTitles.roomAdd,'invite':this.copy.ui.routeTitles.invite,'modules':this.copy.ui.routeTitles.modules,
   'module-detail':e.params.name||this.copy.ui.common.module,'dashboard-edit':this.copy.ui.routeTitles.dashboardEdit,'dashboard-add':this.copy.ui.routeTitles.dashboardAdd,
   'dashboard-items':e.params.category==='rooms'?this.copy.ui.routeTitles.rooms:e.params.category==='habits'?this.copy.ui.nav.habits:this.copy.ui.routeTitles.devices,
   'add-device':this.copy.ui.routeTitles.addDevice,'pair-start':this.copy.ui.routeTitles.addDevice,'pair-qr':this.copy.ui.routeTitles.pairQr,'pair-system':this.copy.ui.routeTitles.addDevice,
   'pair-found':this.copy.ui.routeTitles.pairFound,'pair-name':this.copy.ui.routeTitles.pairName,'pair-room':this.copy.ui.routeTitles.pairRoom,'pair-input':this.copy.ui.routeTitles.pairInput,'pair-done':this.copy.ui.routeTitles.pairDone,
   'habit-name':this.copy.ui.routeTitles.habitName,'habit-builder':this.s.draftHabit.name||this.copy.ui.routeTitles.newHabit,
   'habit-options':e.params.target==='actions'?this.copy.ui.routeTitles.actions:e.params.target==='onlyIf'?this.copy.ui.routeTitles.onlyIf:this.copy.ui.routeTitles.when,
   'habit-config':e.params.title||this.copy.ui.common.configure,'accessory-settings':this.copy.ui.routeTitles.accessorySettings,'rename-accessory':this.copy.ui.routeTitles.renameAccessory,
   'schedule-list':this.copy.ui.common.schedule,'schedule-create':this.copy.ui.routeTitles.newSchedule,'sun-list':this.copy.ui.common.sunriseSunset,'sun-create':this.copy.ui.routeTitles.newRule,
   'room-detail':e.params.name||this.copy.ui.common.room
  };
  return map[e.route]||this.copy.ui.defaultHeading;
 }
 routeRight(e){
  if(e.route==='dashboard-edit')return`<button class="fp-action-text" data-action="dashboard-done">${this.copy.ui.common.done}</button>`;
  if(e.route==='dashboard-items')return`<button class="fp-action-text" data-action="dashboard-add-confirm">${this.copy.ui.common.add}</button>`;
  if(e.route==='habit-builder'&&this.s.draftHabit.when.length&&this.s.draftHabit.actions.length)return`<button class="fp-action-text" data-action="habit-save">${this.copy.ui.common.save}</button>`;
  return'<span></span>';
 }

 routeContent(e){
  const r=e.route,p=e.params;
  if(r==='manage-home')return this.manageHomeRoute();
  if(r==='rooms')return this.roomsRoute();
  if(r==='room-add')return this.roomAddRoute();
  if(r==='invite')return this.inviteRoute();
  if(r==='modules')return this.modulesRoute();
  if(r==='module-detail')return this.moduleDetailRoute(p);
  if(r==='dashboard-edit')return this.dashboardEditRoute();
  if(r==='dashboard-add')return this.dashboardAddRoute();
  if(r==='dashboard-items')return this.dashboardItemsRoute(p);
  if(r==='add-device')return this.addDeviceRoute();
  if(r==='pair-start')return this.pairStartRoute();
  if(r==='pair-qr')return this.pairQrRoute();
  if(r==='pair-system')return this.pairSystemRoute();
  if(r==='pair-found')return this.pairFoundRoute();
  if(r==='pair-name')return this.pairNameRoute();
  if(r==='pair-room')return this.pairRoomRoute();
  if(r==='pair-input')return this.pairInputRoute();
  if(r==='pair-done')return this.pairDoneRoute();
  if(r==='habit-name')return this.habitNameRoute();
  if(r==='habit-builder')return this.habitBuilderRoute();
  if(r==='habit-options')return this.habitOptionsRoute(p);
  if(r==='habit-config')return this.habitConfigRoute(p);
  if(r==='accessory-settings')return this.accessorySettingsRoute(p);
  if(r==='rename-accessory')return this.renameAccessoryRoute(p);
  if(r==='schedule-list')return this.scheduleListRoute(p);
  if(r==='schedule-create')return this.scheduleCreateRoute(p);
  if(r==='sun-list')return this.sunListRoute(p);
  if(r==='sun-create')return this.sunCreateRoute(p);
  if(r==='room-detail')return this.roomDetailRoute(p);
  return`<section class="fp-form-screen"><h2>${this.copy.ui.common.unavailable}</h2></section>`;
 }
 manageHomeRoute(){
  const t=this.flow.manageHome;
  return`<div class="fp-manage-list">
   <button class="fp-list-row" data-action="dialog-rename-home"><span class="fp-list-icon">${I('rename')}</span><span><strong>${E(this.s.home.name)}</strong><small>${E(t.renameHome)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="route" data-route="rooms"><span class="fp-list-icon">${I('room')}</span><span><strong>${E(this.copy.ui.routeTitles.rooms)}</strong><small>${this.s.rooms.length} ${E(t.configuredRooms)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="route" data-route="invite"><span class="fp-list-icon">${I('members')}</span><span><strong>${E(t.inviteMember)}</strong><small>${E(t.shareHomeAccess)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="route" data-route="modules"><span class="fp-list-icon">${I('module')}</span><span><strong>${E(t.moduleSettings)}</strong><small>${E(t.renameOrRemoveModules)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row fp-danger" data-action="dialog-delete-home"><span class="fp-list-icon">${I('trash')}</span><span><strong>${E(t.deleteHome)}</strong><small>${E(t.simulatedOperation)}</small></span>${I('chevron')}</button>
  </div>`;
 }
 roomsRoute(){
  const t=this.flow.room;
  return`<div class="fp-manage-list">
   ${this.s.rooms.map(room=>`<button class="fp-list-row" data-action="room-open" data-id="${room.id}"><span class="fp-list-icon">${I('room')}</span><span><strong>${E(room.name)}</strong><small>${this.roomAccessoryTextLocalized(Object.values(this.s.devices).filter(d=>d.room===room.name).length)}</small></span>${I('chevron')}</button>`).join('')}
   <button class="fp-primary-wide" data-action="route" data-route="room-add">${I('plus')} ${E(this.copy.ui.routeTitles.roomAdd)}</button>
  </div>`;
 }
 roomAddRoute(){
  const t=this.flow.room;
  return`<section class="fp-form-screen">
   <h2>${E(t.whatName)}</h2>
   <div class="fp-field focus"><label>${E(t.enterName)}</label><input data-field="room-name" value=""></div>
   <div class="fp-room-grid">
    ${t.presets.map(n=>`<button class="fp-room-choice" data-action="room-preset" data-value="${n}">${I('room')}<span>${n}</span></button>`).join('')}
   </div>
   <button class="fp-next" data-action="room-save" disabled>${E(this.copy.ui.common.save)}</button>
  </section>`;
 }
 roomDetailRoute(p){
  const t=this.flow.room;
  const room=this.s.rooms.find(r=>r.id===p.id);
  return`<section class="fp-form-screen">
   <div class="fp-field focus"><label>${E(t.roomName)}</label><input data-field="room-edit-name" value="${E(room.name)}"></div>
   <button class="fp-primary-wide" style="margin-top:22px" data-action="room-update" data-id="${room.id}">${E(this.copy.ui.common.save)}</button>
   <button class="fp-secondary-wide fp-danger" style="margin-top:11px" data-action="room-delete" data-id="${room.id}">${E(t.deleteRoom)}</button>
  </section>`;
 }
 inviteRoute(){
  const t=this.flow.invite;
  const code='FP-'+Math.random().toString(36).slice(2,10).toUpperCase();
  return`<section class="fp-form-screen">
   <h2>${E(t.title)}</h2>
   <p style="color:var(--fp-muted);font-size:14px;line-height:1.45">${E(t.body)}</p>
   <div class="fp-field" style="margin-top:28px"><label>${E(t.inviteLink)}</label><input readonly value="freedompro://app/invite?code=${code}"></div>
   <button class="fp-primary-wide" style="margin-top:20px" data-action="copy-invite" data-value="freedompro://app/invite?code=${code}">${I('copy')} ${E(t.copyLink)}</button>
  </section>`;
 }
 modulesRoute(){
  return`<div class="fp-manage-list">${this.s.modules.map(m=>`<button class="fp-list-row" data-action="module-open" data-id="${m.id}"><span class="fp-list-icon">${I('module')}</span><span><strong>${E(m.name)}</strong><small>${E(m.model)} | ${E(m.serial)}</small></span>${I('chevron')}</button>`).join('')}</div>`;
 }
 moduleDetailRoute(p){
  const t=this.flow.module;
  const m=this.s.modules.find(x=>x.id===p.id);
  return`<section class="fp-form-screen">
   <div class="fp-field focus"><label>${E(t.name)}</label><input data-field="module-name" value="${E(m.name)}"></div>
   <div class="fp-list-row" style="margin-top:18px"><span class="fp-list-icon">${I('info')}</span><span><strong>${E(m.model)}</strong><small>${E(t.serial)} ${E(m.serial)}</small></span></div>
   <button class="fp-primary-wide" style="margin-top:20px" data-action="module-save" data-id="${m.id}">${E(this.copy.ui.common.save)}</button>
   <button class="fp-secondary-wide fp-danger" style="margin-top:11px" data-action="module-remove" data-id="${m.id}">${E(t.remove)}</button>
  </section>`;
 }
 dashboardEditRoute(){
  const t=this.flow.dashboard;
  return`<section class="fp-screen">
   <div class="fp-section-title"><h3>${E(this.copy.ui.home.dashboard)}</h3><span style="font-size:11px;color:var(--fp-muted)">${E(t.tapMinus)}</span></div>
   <div class="fp-grid">${this.s.dashboard.map(item=>this.dashboardTile(item,true)).join('')}</div>
   <button class="fp-fab" data-action="route" data-route="dashboard-add">${I('plus')}${E(t.addToDashboard)}</button>
  </section>`;
 }
 dashboardAddRoute(){
  const t=this.flow.dashboard;
  return`<div class="fp-manage-list">
   <button class="fp-list-row" data-action="dashboard-category" data-value="devices"><span class="fp-list-icon">${I('accessories')}</span><span><strong>${E(this.copy.ui.routeTitles.devices)}</strong><small>${E(t.devicesDetail)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="dashboard-category" data-value="rooms"><span class="fp-list-icon">${I('room')}</span><span><strong>${E(this.copy.ui.routeTitles.rooms)}</strong><small>${E(t.roomsDetail)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="dashboard-category" data-value="habits"><span class="fp-list-icon">${habitIcon()}</span><span><strong>${E(this.copy.ui.nav.habits)}</strong><small>${E(t.habitsDetail)}</small></span>${I('chevron')}</button>
  </div>`;
 }
 dashboardItemsRoute(p){
  let items=[];
  if(p.category==='rooms')items=this.s.rooms.map(r=>({kind:'room',id:r.id,name:r.name,detail:`${Object.values(this.s.devices).filter(d=>d.room===r.name).length} accessori`,icon:'room'}));
  else if(p.category==='habits')items=this.s.habits.map(h=>({kind:'habit',id:h.id,name:h.name,detail:h.summary,icon:'habits'}));
  else items=Object.values(this.s.devices).map(d=>({kind:'device',id:d.id,name:d.name,detail:d.room,icon:d.type}));
  return`<div class="fp-manage-list">${items.length?items.map(x=>{
   const key=`${x.kind}:${x.id}`,selected=this.s.selectedDashboardItems.includes(key);
   return`<button class="fp-list-row" data-action="dashboard-item-toggle" data-key="${key}"><span class="fp-list-icon">${I(x.icon)}</span><span><strong>${E(x.name)}</strong><small>${E(x.detail)}</small></span><span style="color:${selected?'var(--fp-blue)':'#a7aeba'}">${I(selected?'check':'plus')}</span></button>`;
  }).join(''):`<div class="fp-empty" style="min-height:400px"><h3>${E(this.flow.dashboard.noItems)}</h3></div>`}</div>`;
 }
 addDeviceRoute(){
  const t=this.flow.pairing;
  return`<div class="fp-manage-list">
   <button class="fp-list-row" data-action="pair-modules"><span class="fp-list-icon">${I('module')}</span><span><strong>${E(t.smartModules)}</strong><small>${E(t.compatibleModule)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="dialog-info" data-title="Easykon" data-text="${E(t.easykonInfo)}"><span class="fp-list-icon">${I('home')}</span><span><strong>Easykon</strong><small>MyHome o KNX</small></span>${I('chevron')}</button>
  </div>`;
 }
 pairStartRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i===0?'active':''}"></i>`).join('')}</div>
   <div class="fp-pair-card">
    <div class="fp-pair-visual">${I('module')}</div>
    <h2>${E(t.isNew)}</h2>
    <p>${E(t.choosePath)}</p>
    <div style="display:grid;gap:10px;margin-top:28px">
     <button class="fp-primary-wide" data-action="pair-new">${E(t.newModule)}</button>
     <button class="fp-secondary-wide" data-action="dialog-info" data-title="${E(t.alreadyConfiguredTitle)}" data-text="${E(t.alreadyConfiguredText)}">${E(t.alreadyConfigured)}</button>
    </div>
   </div>
  </section>`;
 }
 pairQrRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<1?'done':i===1?'active':''}"></i>`).join('')}</div>
   <div class="fp-pair-card">
    <div class="fp-qr">QR DEMO</div>
    <h2>${E(this.copy.ui.routeTitles.pairQr)}</h2>
    <p>${E(t.useMatterCode)}</p>
    <button class="fp-primary-wide" style="margin-top:28px" data-action="pair-scan">${E(t.scanQr)}</button>
   </div>
  </section>`;
 }
 pairSystemRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<2?'done':i===2?'active':''}"></i>`).join('')}</div>
   <div class="fp-pair-card">
    <div class="fp-pair-visual">${I('wifi')}</div>
    <h2>${E(t.letsStart)}</h2>
    <p>${E(t.systemPairing)}</p>
    <button class="fp-primary-wide" style="margin-top:28px" data-action="pair-system-finish">${E(t.finish)}</button>
   </div>
  </section>`;
 }
 pairFoundRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<3?'done':i===3?'active':''}"></i>`).join('')}</div>
   <div class="fp-pair-card">
    <div class="fp-pair-visual">${I('light')}</div>
    <h2>LB0801-E</h2>
    <p>${E(t.foundReady)}</p>
    <button class="fp-primary-wide" style="margin-top:28px" data-action="pair-found-next">${E(this.copy.ui.common.continue)}</button>
   </div>
  </section>`;
 }
 pairNameRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<4?'done':i===4?'active':''}"></i>`).join('')}</div>
   <h2>${E(t.nameQuestion)}</h2>
   <div class="fp-field focus"><label>${E(t.accessoryName)}</label><input data-field="pair-name" value="${E(this.s.pairing.name)}"></div>
   <button class="fp-next enabled" data-action="pair-name-next">${E(this.copy.ui.common.next)}</button>
  </section>`;
 }
 pairRoomRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<4?'done':i===4?'active':''}"></i>`).join('')}</div>
   <h2>${E(t.roomQuestion)}</h2>
   <div class="fp-room-grid">${this.s.rooms.map(r=>`<button class="fp-room-choice ${this.s.pairing.room===r.name?'selected':''}" data-action="pair-room-select" data-value="${E(r.name)}">${I('room')}<span>${E(r.name)}</span></button>`).join('')}</div>
   <button class="fp-primary-wide" data-action="pair-room-next">${E(this.copy.ui.common.next)}</button>
  </section>`;
 }
 pairInputRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-stepper">${[0,1,2,3,4,5].map((_,i)=>`<i class="${i<5?'done':i===5?'active':''}"></i>`).join('')}</div>
   <h2>${E(t.commandType)}</h2>
   <div class="fp-input-type-list">${t.types.map(type=>`<button class="fp-input-type ${this.s.pairing.input===type?'selected':''}" data-action="pair-input-select" data-value="${E(type)}"><span>${E(type)}</span>${this.s.pairing.input===type?I('check'):''}</button>`).join('')}</div>
   <button class="fp-primary-wide" data-action="pair-input-next">${E(this.copy.ui.common.next)}</button>
  </section>`;
 }
 pairDoneRoute(){
  const t=this.flow.pairing;
  return`<section class="fp-form-screen">
   <div class="fp-pair-card">
    <div class="fp-pair-visual" style="background:#e4f7ee;color:#087a57">${I('check')}</div>
    <h2>${E(this.s.pairing.name)}</h2>
    <p>${E(t.addedTo)} ${E(this.s.pairing.room)} ${E(t.withCommand)} ${E(this.s.pairing.input)}.</p>
    <button class="fp-primary-wide" style="margin-top:28px" data-action="pair-go-accessories">${E(t.goToAccessories)}</button>
   </div>
  </section>`;
 }

 habitNameRoute(){
  const t=this.flow.habits;
  const enabled=this.s.draftHabit.name.trim().length>0;
  return`<section class="fp-form-screen">
   <h2>${E(t.nameQuestion)}</h2>
   <div class="fp-sparkles">${I('sparkles')}</div>
   <div class="fp-field focus"><label>${E(t.placeholderExample)}</label><input data-field="habit-name" value="${E(this.s.draftHabit.name)}" autofocus></div>
   <button class="fp-next ${enabled?'enabled':''}" data-action="habit-name-next" ${enabled?'':'disabled'}>→&nbsp;&nbsp;${E(this.copy.ui.common.next)}</button>
  </section>`;
 }
 habitBuilderRoute(){
  const t=this.flow.habits;
  const d=this.s.draftHabit;
  const items=(arr,target)=>arr.map((x,i)=>`<div class="fp-builder-item">
   <span class="fp-option-icon">${optionListIcon(x.icon)}</span>
   <span><strong>${E(x.title)}</strong><small>${E(x.detail)}</small></span>
   <button class="fp-builder-remove" data-action="habit-component-remove" data-target="${target}" data-index="${i}"><span class="material-symbols-outlined fp-builder-remove-symbol" aria-hidden="true">remove_circle</span></button>
  </div>`).join('');
  return`<section class="fp-builder">
   <div class="fp-builder-block"><h2>${E(t.when)}</h2><p>${E(t.whenHelp)}</p>${items(d.when,'when')}<button class="fp-add-row" data-action="habit-options" data-target="when">${I('plus')}${E(t.addCondition)}</button></div>
   <div class="fp-builder-block secondary"><h2>${E(t.onlyIf)}</h2><p>${E(t.onlyIfHelp)}</p>${items(d.onlyIf,'onlyIf')}<button class="fp-add-row" data-action="habit-options" data-target="onlyIf">${I('plus')}${E(t.addCondition)}</button></div>
   <div class="fp-builder-block"><h2>${E(t.run)}</h2><p>${E(t.runHelp)}</p>${items(d.actions,'actions')}<button class="fp-add-row" data-action="habit-options" data-target="actions">${I('plus')}${E(t.addEvent)}</button></div>
  </section>`;
 }
 habitOptionItems(target){
  return this.habitCatalog(target);
 }
 habitOptionsRoute(p){
 return`<div class="fp-option-list">${this.habitOptionItems(p.target).map(x=>`<button class="fp-option" data-action="habit-config-open" data-target="${p.target}" data-kind="${x.kind}" data-title="${E(x.title)}">
   <span class="fp-option-icon">${optionListIcon(x.icon)}</span><span><strong>${E(x.title)}</strong><small>${E(x.detail)}</small></span>${I('chevron')}
  </button>`).join('')}</div>`;
}
 habitConfigRoute(p){
  const labels=this.localizedLabels();
  const devices=Object.values(this.s.devices);
  const modules=this.s.modules;
  const days=this.localizedWeekdays();
  const kind=p.kind;
  const defaultAccessoryDeviceId=devices.find(d=>['light','outlet'].includes(d.type))?.id||devices[0]?.id;
  const defaultShutterDeviceId=devices.find(d=>d.type==='shutter')?.id||defaultAccessoryDeviceId;
  const currentDeviceId=this.dropdownValue('cfg-device',this.field('cfg-device')||(kind==='action-shutter'?defaultShutterDeviceId:defaultAccessoryDeviceId));
  const currentDevice=devices.find(d=>d.id===currentDeviceId)||devices[0];
  const isShutterLike=currentDevice&&['shutter'].includes(currentDevice.type);
  const deviceOptions=(filterFn)=>devices.filter(filterFn).map(d=>({value:d.id,label:d.name}));
  const moduleOptions=modules.map(m=>({value:m.id,label:m.model}));
  const fallbackHabitName=(DEMO_SEED_COPY[this.locale]||DEMO_SEED_COPY.it).habits.habitNight.name;
  const habitOptions=(this.s.habits.length?this.s.habits:[{id:'habitExit',name:fallbackHabitName}]).map(h=>({value:h.id,label:h.name}));
  const accessoryStateOptions=(()=>{
   if(kind==='action-accessory'){
    if(isShutterLike)return[labels.open,labels.close];
    return[labels.turnOn,labels.turnOff];
   }
   if(kind==='query-accessory'){
    if(isShutterLike)return[this.copy.ui.states.open,this.copy.ui.states.closed];
    return[labels.ifOn,labels.ifOff];
   }
   return[labels.stateChanged,labels.turnsOn,labels.turnsOff];
  })();
  if(kind==='trigger-schedule')return`<section class="fp-form-screen">
   <div class="fp-field focus"><label>${E(this.copy.ui.common.schedule)}</label><input type="time" data-field="cfg-time" value="08:00"></div>
   <div class="fp-filter-row" style="margin-top:22px">${days.map((d,i)=>`<button class="fp-filter-chip active ${i>=5?'is-weekend':''}" data-toggle-day="${d}">${d}</button>`).join('')}</div>
  </section>`;
  if(kind==='trigger-sun')return`<section class="fp-form-screen fp-sun-form-screen">
   <div class="fp-segment fp-form-segment fp-sun-segment">
    ${[labels.sunrise,labels.sunset].map((x,i)=>`<button class="${i===0?'selected active':''}" data-single-choice="cfg-event" data-value="${x}">${i===0?`<span class="fp-sun-segment-check" aria-hidden="true">${I('check')}</span>`:''}<span>${x}</span></button>`).join('')}
   </div>
   <p class="fp-sun-next-copy" data-sun-next>${E(labels.nextSunrise)}</p>
   <div class="fp-form-toggle-row fp-sun-toggle-row">
    <span class="fp-sun-toggle-icon" aria-hidden="true">${I('clock')}</span>
    <span class="fp-form-toggle-label">${E(labels.delay)}</span>
    <button class="fp-form-toggle-switch" type="button" data-action="official-app-toast" aria-label="${E(labels.delay)}"><i></i></button>
   </div>
   <div class="fp-filter-row">${days.map((d,i)=>`<button class="fp-filter-chip ${i<4?'active':''} ${i>=5?'is-weekend':''}" data-toggle-day="${d}">${d}</button>`).join('')}</div>
  </section>`;
  if(kind==='trigger-daynight'||kind==='query-daynight')return`<section class="fp-form-screen fp-sun-form-screen">
   <div class="fp-segment fp-form-segment fp-sun-segment">
    ${[labels.day,labels.night].map((x,i)=>`<button class="${i===0?'selected active':''}" data-single-choice="cfg-event" data-value="${x}">${i===0?`<span class="fp-sun-segment-check" aria-hidden="true">${I('check')}</span>`:''}<span>${x}</span></button>`).join('')}
   </div>
   <div class="fp-form-toggle-row fp-sun-toggle-row">
    <span class="fp-sun-toggle-icon" aria-hidden="true">${I('clock')}</span>
    <span class="fp-form-toggle-label">${E(labels.delay)}</span>
    <button class="fp-form-toggle-switch" type="button" data-action="official-app-toast" aria-label="${E(labels.delay)}"><i></i></button>
   </div>
   <div class="fp-filter-row">${days.map((d,i)=>`<button class="fp-filter-chip ${i<4?'active':''} ${i>=5?'is-weekend':''}" data-toggle-day="${d}">${d}</button>`).join('')}</div>
  </section>`;
  if(kind.includes('consumption'))return`<section class="fp-form-screen">
   ${this.formDropdownHtml('cfg-device',this.copy.ui.common.accessory,deviceOptions(d=>['light','outlet'].includes(d.type)),currentDeviceId)}
   <div class="fp-segment fp-form-segment fp-consumption-segment">
    ${[labels.lessThan,labels.greaterThan].map((x,i)=>`<button class="${i===0?'selected active':''}" data-single-choice="cfg-comparison" data-value="${x}">${i===0?`<span class="fp-sun-segment-check" aria-hidden="true">${I('check')}</span>`:''}<span>${x}</span></button>`).join('')}
   </div>
   <div class="fp-field fp-threshold-field"><label>${E(labels.threshold)}</label><input type="number" data-field="cfg-threshold" value="500"><span class="fp-threshold-unit" aria-hidden="true">W</span></div>
  </section>`;
  if(kind==='action-shutter')return`<section class="fp-form-screen">
   ${this.formDropdownHtml('cfg-device',this.copy.ui.accessories.types.shutter,deviceOptions(d=>d.type==='shutter'),currentDeviceId)}
   <div class="fp-input-type-list">${[labels.open,labels.close].map((x,i)=>`<button class="fp-input-type ${i===0?'selected':''}" data-single-choice="cfg-state" data-value="${x}"><span>${x}</span>${i===0?I('check'):''}</button>`).join('')}</div>
  </section>`;
  if(kind.includes('accessory'))return`<section class="fp-form-screen">
   ${this.formDropdownHtml('cfg-device',this.copy.ui.common.accessory,deviceOptions(()=>true),currentDeviceId)}
   <div class="fp-input-type-list">${accessoryStateOptions.map((x,i)=>`<button class="fp-input-type ${i===0?'selected':''}" data-single-choice="cfg-state" data-value="${x}"><span>${x}</span>${i===0?I('check'):''}</button>`).join('')}</div>
  </section>`;
  if(kind.includes('module'))return`<section class="fp-form-screen">
   ${this.formDropdownHtml('cfg-module',this.copy.ui.common.module,moduleOptions,this.dropdownValue('cfg-module',this.field('cfg-module')||modules[0]?.id))}
   <div class="fp-input-type-list">${(kind==='query-module'?[labels.ifOnline,labels.ifOffline]:[labels.stateChanged,labels.goesOnline,labels.goesOffline]).map((x,i)=>`<button class="fp-input-type ${i===0?'selected':''}" data-single-choice="cfg-state" data-value="${x}"><span>${x}</span>${i===0?I('check'):''}</button>`).join('')}</div>
  </section>`;
  if(kind==='query-time')return`<section class="fp-form-screen">
   <div class="fp-field focus"><label>${E(labels.from)}</label><input type="time" data-field="cfg-from" value="08:00"></div>
   <div class="fp-field" style="margin-top:16px"><label>${E(labels.to)}</label><input type="time" data-field="cfg-to" value="14:59"></div>
   <div class="fp-filter-row" style="margin-top:22px">${days.map((d,i)=>`<button class="fp-filter-chip active ${i>=5?'is-weekend':''}" data-toggle-day="${d}">${d}</button>`).join('')}</div>
  </section>`;
  if(kind==='action-notification')return`<section class="fp-form-screen">
   <div class="fp-field focus"><label>${E(labels.notificationTitle)}</label><input data-field="cfg-title" value="${E(labels.notificationTitleValue)}"></div>
   <div class="fp-field" style="margin-top:16px"><label>${E(labels.notificationMessage)}</label><textarea rows="4" data-field="cfg-message">${E(labels.notificationMessageValue)}</textarea></div>
  </section>`;
  if(kind==='action-wait')return`<section class="fp-form-screen fp-wait-form-screen">
   <div class="fp-wait-grid">
    <div class="fp-field focus"><label>${E(labels.hours)}</label><input type="number" data-field="cfg-hours" value="1"></div>
    <div class="fp-field"><label>${E(labels.minutes)}</label><input type="number" data-field="cfg-minutes" value="5"></div>
   </div>
  </section>`;
  if(kind==='action-habit')return`<section class="fp-form-screen">${this.formDropdownHtml('cfg-habit',this.copy.ui.nav.habits,habitOptions,this.dropdownValue('cfg-habit',this.field('cfg-habit')||habitOptions[0]?.value))}<div class="fp-input-type-list"><button class="fp-input-type selected" data-single-choice="cfg-state" data-value="${E(labels.start)}"><span>${E(labels.start)}</span>${I('check')}</button><button class="fp-input-type" data-single-choice="cfg-state" data-value="${E(labels.stop)}"><span>${E(labels.stop)}</span></button></div></section>`;
  if(kind==='trigger-nfc')return`<section class="fp-form-screen"><p style="color:var(--fp-muted);line-height:1.5">${E(labels.simulateScan)}</p><div class="fp-pair-visual" style="margin:35px auto">${I('nfc')}</div></section>`;
  return`<section class="fp-form-screen"></section>`;
 }
 accessorySettingsRoute(p){
  const d=this.device(p.id);
  const labels=this.localizedLabels();
  return`<div class="fp-manage-list">
   <button class="fp-list-row" data-action="rename-accessory-open" data-id="${d.id}"><span class="fp-list-icon">${I('rename')}</span><span><strong>${E(this.copy.ui.common.rename)}</strong><small>${E(d.name)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="dialog-info" data-title="${E(this.copy.ui.common.room)}" data-text="${E(labels.assignedTo)} ${E(d.room)}"><span class="fp-list-icon">${I('room')}</span><span><strong>${E(this.copy.ui.common.room)}</strong><small>${E(d.room)}</small></span>${I('chevron')}</button>
   <button class="fp-list-row" data-action="dialog-info" data-title="${E(this.copy.ui.common.module)}" data-text="${E(d.module)}"><span class="fp-list-icon">${I('module')}</span><span><strong>${E(this.copy.ui.common.module)}</strong><small>${E(d.module)}</small></span>${I('chevron')}</button>
  </div>`;
 }
 renameAccessoryRoute(p){
  const d=this.device(p.id);
  return`<section class="fp-form-screen"><h2>${E(this.copy.ui.routeTitles.renameAccessory)}</h2><div class="fp-field focus"><label>${E(this.copy.ui.common.rename)}</label><input data-field="rename-accessory" value="${E(d.name)}"></div><button class="fp-primary-wide" style="margin-top:24px" data-action="rename-accessory-save" data-id="${d.id}">${E(this.copy.ui.common.save)}</button></section>`;
 }
 scheduleListRoute(p){
  const list=this.s.schedules[p.id]||[];
  const emptyMap={it:'Nessuna programmazione impostata',en:'No schedule set',es:'No hay ningún programa configurado',de:'Kein Zeitplan eingestellt',fr:'Aucune programmation définie'};
  return`<div class="fp-schedule-list">${list.length?list.map((x,i)=>`<div class="fp-list-row"><span class="fp-list-icon">${I('clock')}</span><span><strong>${E(x.time)}</strong><small>${E(x.days)} · ${E(x.action)}</small></span><button class="fp-action-icon fp-danger" data-action="schedule-delete" data-id="${p.id}" data-index="${i}">${I('trash')}</button></div>`).join(''):`<div class="fp-empty" style="min-height:430px"><h3>${E(emptyMap[this.locale]||emptyMap.it)}</h3></div>`}<button class="fp-primary-wide" data-action="schedule-create-open" data-id="${p.id}">${E(this.copy.ui.common.create)}</button></div>`;
 }
 scheduleCreateRoute(p){
  const labels=this.localizedLabels();
  return`<section class="fp-form-screen"><h2>${E(this.copy.ui.common.schedule)}</h2><div class="fp-field focus"><label>${E(this.copy.ui.common.schedule)}</label><input type="time" data-field="schedule-time" value="00:01"></div><div class="fp-field" style="margin-top:16px"><label>${E(this.copy.ui.common.accessory)}</label><select data-field="schedule-action"><option>${E(labels.turnOn)}</option><option>${E(labels.turnOff)}</option></select></div><div class="fp-filter-row" style="margin-top:22px">${this.localizedWeekdays().map((d,i)=>`<button class="fp-filter-chip active ${i>=5?'is-weekend':''}" data-toggle-day="${d}">${d}</button>`).join('')}</div><button class="fp-primary-wide" data-action="schedule-save" data-id="${p.id}">${E(this.copy.ui.common.save)}</button></section>`;
 }
 sunListRoute(p){
  const list=this.s.sunRules[p.id]||[];
  const emptyMap={it:'Nessuna regola impostata per Alba o Tramonto',en:'No rule set for sunrise or sunset',es:'No hay ninguna regla configurada para amanecer o atardecer',de:'Keine Regel für Sonnenaufgang oder Sonnenuntergang festgelegt',fr:'Aucune règle définie pour le lever ou le coucher du soleil'};
  return`<div class="fp-schedule-list">${list.length?list.map((x,i)=>`<div class="fp-list-row"><span class="fp-list-icon">${I('sunset')}</span><span><strong>${E(x.event)}</strong><small>${E(x.action)} · ${E(x.offset)}</small></span><button class="fp-action-icon fp-danger" data-action="sun-delete" data-id="${p.id}" data-index="${i}">${I('trash')}</button></div>`).join(''):`<div class="fp-empty" style="min-height:430px"><h3>${E(emptyMap[this.locale]||emptyMap.it)}</h3></div>`}<button class="fp-primary-wide" data-action="sun-create-open" data-id="${p.id}">${E(this.copy.ui.common.create)}</button></div>`;
 }
 sunCreateRoute(p){
  const labels=this.localizedLabels();
  return`<section class="fp-form-screen"><h2>${E(this.copy.ui.common.sunriseSunset)}</h2><div class="fp-input-type-list"><button class="fp-input-type" data-single-choice="sun-event" data-value="${E(labels.sunrise)}"><span>${E(labels.sunrise)}</span></button><button class="fp-input-type selected" data-single-choice="sun-event" data-value="${E(labels.sunset)}"><span>${E(labels.sunset)}</span>${I('check')}</button></div><div class="fp-input-type-list"><button class="fp-input-type selected" data-single-choice="sun-action" data-value="${E(this.copy.ui.states.on)}"><span>${E(this.copy.ui.states.on)}</span>${I('check')}</button><button class="fp-input-type" data-single-choice="sun-action" data-value="${E(this.copy.ui.states.off)}"><span>${E(this.copy.ui.states.off)}</span></button></div><div class="fp-field"><label>${E(labels.delay)}</label><input type="number" data-field="sun-offset" value="0"></div><button class="fp-primary-wide" style="margin-top:24px" data-action="sun-save" data-id="${p.id}">${E(this.copy.ui.common.save)}</button></section>`;
 }

 renderOverlay(){
  if(!this.overlay)return'';
  const o=this.overlay;
  const labels=this.localizedLabels();
  if(o.kind==='home-menu')return`<div class="fp-popover fp-home-popover" style="left:15px;right:auto">
   <div class="fp-home-popover-group fp-home-popover-homes">
    ${this.s.homeChoices.map(name=>`<button class="fp-home-popover-home ${this.s.home.name===name?'is-active':''}" type="button" data-action="official-app-toast"><span>${E(name)}</span>${this.s.home.name===name?`<span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-check" aria-hidden="true">done</span>`:''}</button>`).join('')}
   </div>
   <div class="fp-home-popover-group">
    <button type="button" data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">settings</span><span><strong>${E(this.flow.overlay.manageHome)}</strong></span></button>
    <button type="button" data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">notifications</span><span><strong>${E(this.flow.overlay.notificationCenter)}</strong></span></button>
   </div>
   <div class="fp-home-popover-group">
    <button class="fp-home-popover-profile" type="button" data-action="official-app-toast"><span class="fp-home-popover-avatar" aria-hidden="true">A</span><span><strong>${E(this.s.profile.name)}</strong><small>${E(this.s.profile.subtitle)}</small></span></button>
   </div>
  </div>`;
  if(o.kind==='plus-menu')return`<div class="fp-popover fp-home-popover fp-plus-popover">
   <div class="fp-home-popover-group">
    <button data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">lightbulb</span><span><strong>${E(this.flow.overlay.addDevice)}</strong></span></button>
   </div>
   <div class="fp-home-popover-group">
    <button data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">new_window</span><span><strong>${E(this.flow.overlay.addRoom)}</strong></span></button>
    <button class="fp-home-popover-accent" data-action="overlay-habit-create"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">auto_awesome</span><span><strong>${E(this.flow.overlay.createHabit)}</strong></span></button>
    <button data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">group_add</span><span><strong>${E(this.flow.overlay.addUser)}</strong></span></button>
    <button data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">nfc</span><span><strong>${E(this.flow.overlay.addNfcTag)}</strong></span></button>
   </div>
   <div class="fp-home-popover-group">
    <button data-action="official-app-toast"><span class="material-symbols-outlined fp-home-popover-symbol fp-home-popover-icon" aria-hidden="true">add_home</span><span><strong>${E(this.flow.overlay.createHome)}</strong></span></button>
   </div>
  </div>`;
  if(o.kind==='device')return this.deviceSheet(o.id);
  if(o.kind==='device-menu')return'';
  if(o.kind==='habit')return this.habitSheet(o.id);
  if(o.kind==='habit-menu')return this.habitMenuSheet(o.id);
  if(o.kind==='room')return this.roomSheet(o.id);
  if(o.kind==='dialog')return this.dialogHtml(o,labels);
  return'';
 }
 syncOverlay(){
  this.shadowRoot.querySelector('[data-overlay]').innerHTML=this.renderOverlay();
 }
 showOverlay(o){this.overlay=o;this.syncOverlay()}
 closeOverlay(){
  const sheet=this.shadowRoot.querySelector('.fp-sheet');
  if(sheet){
   sheet.classList.add('is-closing');
   setTimeout(()=>{this.overlay=null;this.syncOverlay()},210);
  }else{
   this.overlay=null;this.syncOverlay();
  }
 }
 deviceSheet(id){
  const d=this.device(id);
  if(!d)return'';
  if(d.type==='shutter')return this.shutterSheet(d);
  return`<div class="fp-overlay" data-action="overlay-close"><section class="fp-sheet fp-accessory-sheet" data-action="stop">
   <div class="fp-sheet-handle"></div>
   <div class="fp-sheet-header"><span class="fp-entity-icon ${d.type} ${d.on?'on':''}" data-device-sheet-icon="${d.id}">${entityIcon(d.type)}</span><span><h3>${E(d.name)}</h3><p>${E(d.room)}</p></span><button class="fp-close" data-action="overlay-close">${I('close')}</button></div>
   <div class="fp-sheet-body">
    <div class="fp-light-control"><button class="fp-big-power ${d.type} ${d.on?'':'off'}" data-action="device-toggle" data-id="${d.id}" data-device-toggle="${d.id}">${I('power')}</button></div>
    <div class="fp-sheet-footer"><button data-action="device-consumption" data-id="${d.id}">${F('equalizer')}</button><button data-action="device-settings" data-id="${d.id}">${F('settings')}</button></div>
   </div>
  </section></div>`;
 }
 shutterSheet(d){
  const pos=Math.max(0,Math.min(100,d.position));
  const visual=100-pos;
  return`<div class="fp-overlay" data-action="overlay-close"><section class="fp-sheet fp-accessory-sheet" data-action="stop">
   <div class="fp-sheet-handle"></div>
   <div class="fp-sheet-header"><span class="fp-entity-icon shutter ${pos>0?'on':''}" data-device-sheet-icon="${d.id}">${entityIcon('shutter')}</span><span><h3>${E(d.name)}</h3><p>${E(d.room)}</p></span><button class="fp-close" data-action="overlay-close">${I('close')}</button></div>
   <div class="fp-sheet-body">
    <div class="fp-shutter-control"><span class="fp-shutter-label">${E(this.flow.overlay.open)}</span><div class="fp-vertical-wrap">
     <div class="fp-vertical-track" data-role="shutter-track" data-id="${d.id}" role="slider" aria-label="Posizione ${E(d.name)}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(pos)}"><div class="fp-vertical-fill" style="height:${visual}%"></div><div class="fp-vertical-line" style="top:${visual}%"></div></div>
     <span class="fp-percent-bubble" style="top:${visual}%">${Math.round(pos)}%</span>
    </div><span class="fp-shutter-label">${E(this.flow.overlay.closed)}</span></div>
    <div class="fp-sheet-footer"><button data-action="device-consumption" data-id="${d.id}">${F('equalizer')}</button><button data-action="device-settings" data-id="${d.id}">${F('settings')}</button></div>
   </div>
  </section></div>`;
 }
 deviceMenuSheet(id){
  return'';
 }
 habitSheet(id){
  const h=this.s.habits.find(x=>x.id===id);
  return`<div class="fp-overlay" data-action="overlay-close"><section class="fp-sheet fp-accessory-sheet fp-habit-sheet" data-action="stop">
   <div class="fp-sheet-handle"></div>
   <div class="fp-sheet-header"><span class="fp-entity-icon habit ${h.active?'on':''}">${habitIcon()}</span><span><h3>${E(h.name)}</h3><p>${h.disabled?E(this.localizedLabels().inactive):E(h.summary)}</p></span><button class="fp-close" data-action="overlay-close">${I('close')}</button></div>
   <div class="fp-sheet-body">
    <div class="fp-light-control"><button class="fp-big-power habit ${h.active?'':'off'}" data-action="habit-run" data-id="${h.id}">${F(h.active?'pause':'play_arrow')}</button></div>
    <div class="fp-sheet-footer"><button data-action="habit-menu-open" data-id="${h.id}">${F('settings')}</button></div>
   </div>
  </section></div>`;
 }
 habitMenuSheet(id){
  const h=this.s.habits.find(x=>x.id===id);
  return`<div class="fp-overlay" data-action="overlay-close"><section class="fp-sheet" style="min-height:360px;height:auto" data-action="stop">
   <div class="fp-sheet-handle"></div>
   <div class="fp-sheet-header"><span class="fp-entity-icon habit">${habitIcon()}</span><span><h3>${E(h.name)}</h3><p>${h.disabled?E(this.copy.ui.states.inactive):E(this.copy.ui.states.active)}</p></span><button class="fp-close" data-action="overlay-close">${I('close')}</button></div>
   <div class="fp-sheet-menu">
    <button data-action="habit-rename-dialog" data-id="${h.id}">${I('rename')}<span><strong>${E(this.flow.overlay.rename)}</strong><small>${E(this.flow.overlay.editName)}</small></span>${I('chevron')}</button>
    <button data-action="habit-enable-toggle" data-id="${h.id}">${I(h.disabled?'play':'pause')}<span><strong>${E(h.disabled?this.flow.overlay.enable:this.flow.overlay.disable)}</strong><small>${E(h.disabled?this.flow.overlay.makeAvailable:this.flow.overlay.preventAuto)}</small></span>${I('chevron')}</button>
    <button class="fp-danger" data-action="habit-delete-dialog" data-id="${h.id}">${I('trash')}<span><strong>${E(this.flow.overlay.delete)}</strong><small>${E(this.flow.overlay.removeHabit)}</small></span>${I('chevron')}</button>
   </div>
  </section></div>`;
 }
 roomSheet(id){
  const room=this.s.rooms.find(r=>r.id===id),devices=Object.values(this.s.devices).filter(d=>d.room===room.name);
  return`<div class="fp-overlay" data-action="overlay-close"><section class="fp-sheet" data-action="stop"><div class="fp-sheet-handle"></div><div class="fp-sheet-header"><span class="fp-entity-icon room">${I('room')}</span><span><h3>${E(room.name)}</h3><p>${this.roomAccessoryTextLocalized(devices.length)}</p></span><button class="fp-close" data-action="overlay-close">${I('close')}</button></div><div class="fp-sheet-menu">${devices.map(d=>`<button data-action="room-device-open" data-id="${d.id}" data-device-id="${d.id}"><span class="fp-entity-icon ${d.type} ${(d.on||d.position>0)?'on':''}" style="width:34px;height:34px">${entityIcon(d.type)}</span><span><strong>${E(d.name)}</strong><small>${E(this.deviceStateLabel(d))}</small></span>${I('chevron')}</button>`).join('')}</div></section></div>`;
 }
 dialogHtml(o,labels=this.localizedLabels()){
  let body='';
  if(o.input)body=`<div class="fp-field focus"><label>${E(o.label||labels.value)}</label><input data-field="dialog-input" value="${E(o.value||'')}"></div>`;
  return`<div class="fp-dialog-wrap" data-action="dialog-cancel"><section class="fp-dialog" data-action="stop"><h3>${E(o.title)}</h3><p>${E(o.text||'')}</p>${body}<div class="fp-dialog-actions"><button class="secondary" data-action="dialog-cancel">${E(this.copy.ui.common.cancel)}</button>${o.confirm?`<button class="primary" data-action="dialog-confirm">${E(o.confirmLabel||this.copy.ui.common.confirm)}</button>`:`<button class="primary" data-action="dialog-cancel">${E(this.copy.ui.common.ok)}</button>`}</div></section></div>`;
 }
 info(title,text){this.showOverlay({kind:'dialog',title,text})}
 confirm(title,text,onConfirm,options={}){
  this.showOverlay({kind:'dialog',title,text,confirm:true,confirmLabel:options.confirmLabel||this.copy.ui.common.confirm,input:options.input,label:options.label,value:options.value,onConfirm});
 }
 field(name,scope){
  const root=scope||this.currentRoute()?.page||this.shadowRoot;
  return root.querySelector(`[data-field="${name}"]`)?.value??'';
 }
 selectedChoice(group,root){
  const scope=root||this.currentRoute()?.page||this.shadowRoot;
  return scope.querySelector(`[data-single-choice="${group}"].selected`)?.dataset.value||'';
 }
 selectedDays(root){
  const scope=root||this.currentRoute()?.page||this.shadowRoot;
  return [...scope.querySelectorAll('[data-toggle-day].active')].map(b=>b.dataset.toggleDay);
 }
 dropdownValue(field,fallback=''){
  return this.s.formValues[field]??fallback;
 }
 dropdownLabel(items,value){
  const item=items.find(x=>String(x.value)===String(value));
  return item?.label??items[0]?.label??'';
 }
 formDropdownHtml(field,label,items,selectedValue=''){
  const value=this.dropdownValue(field,selectedValue||items[0]?.value||'');
  const selected=items.find(x=>String(x.value)===String(value))||items[0]||{label:'',value:''};
  const open=this.s.formDropdown===field;
  return`<div class="fp-field fp-form-dropdown-wrap ${open?'is-open':''}" data-form-dropdown="${field}">
   <label>${E(label)}</label>
   <input type="hidden" data-field="${field}" value="${E(value)}">
   <button class="fp-form-dropdown-button" type="button" data-action="form-dropdown-toggle" data-field="${field}" aria-expanded="${open}">
    <span class="fp-form-dropdown-value">${E(selected.label)}</span>
    <span class="fp-form-dropdown-chevron">${I('expandMore')}</span>
   </button>
   <div class="fp-form-dropdown-menu" ${open?'':'hidden'}>
    ${items.map(item=>`<button class="fp-form-dropdown-item ${String(item.value)===String(value)?'is-selected':''}" type="button" data-action="form-dropdown-select" data-field="${field}" data-value="${E(item.value)}" data-label="${E(item.label)}">${E(item.label)}${String(item.value)===String(value)?I('check'):''}</button>`).join('')}
   </div>
  </div>`;
 }

 click(e){
  const choice=e.target.closest('[data-single-choice]');
  if(choice){
   const group=choice.dataset.singleChoice;
   const scope=this.currentRoute()?.page||this.shadowRoot;
   const isSegment=!!choice.closest('.fp-segment');
   scope.querySelectorAll(`[data-single-choice="${group}"]`).forEach(x=>{
    x.classList.remove('selected');
    x.classList.remove('active');
    const check=x.querySelector('.fp-sun-segment-check');
    if(check)check.remove();
    const mark=x.querySelector(':scope > svg');
    if(mark)mark.remove();
   });
   choice.classList.add('selected');
   if(isSegment){
    choice.classList.add('active');
    if(group==='cfg-event'&&choice.closest('.fp-sun-segment')){
     choice.insertAdjacentHTML('afterbegin',`<span class="fp-sun-segment-check" aria-hidden="true">${I('check')}</span>`);
     const nextCopy=scope.querySelector('[data-sun-next]');
     if(nextCopy){
      const labels=this.localizedLabels();
      nextCopy.textContent=choice.dataset.value===labels.sunrise?labels.nextSunrise:labels.nextSunset;
     }
    }
   }else{
    choice.insertAdjacentHTML('beforeend',I('check'));
   }
   if(this.s.formDropdown){
    const openWrap=scope.querySelector(`.fp-form-dropdown-wrap[data-form-dropdown="${this.s.formDropdown}"]`);
    if(openWrap){
     openWrap.classList.remove('is-open');
     const menu=openWrap.querySelector('.fp-form-dropdown-menu');
     if(menu)menu.hidden=true;
     this.s.formDropdown='';
    }
   }
   return;
  }
 const day=e.target.closest('[data-toggle-day]');
 if(day){
  const scope=this.currentRoute()?.page||this.shadowRoot;
  day.classList.toggle('active');
  if(this.s.formDropdown){
   const openWrap=scope.querySelector(`.fp-form-dropdown-wrap[data-form-dropdown="${this.s.formDropdown}"]`);
   if(openWrap){
    openWrap.classList.remove('is-open');
    const menu=openWrap.querySelector('.fp-form-dropdown-menu');
    if(menu)menu.hidden=true;
    this.s.formDropdown='';
   }
  }
  return;
 }
 const accessoryDropdownWrap=e.target.closest('.fp-accessory-dropdown-wrap');
  const formDropdownWrap=e.target.closest('.fp-form-dropdown-wrap');
  const popover=e.target.closest('.fp-popover');
  const b=e.target.closest('[data-action]');
  if((this.overlay?.kind==='home-menu'||this.overlay?.kind==='plus-menu')&&!popover){
   this.overlay=null;
   this.syncOverlay();
  }
  if(!b){
   if((this.s.accessoryDropdown||this.s.consumptionDropdown)&&!accessoryDropdownWrap){
    this.s.accessoryDropdown='';
    this.s.consumptionDropdown='';
    this.refreshBase();
   }
   if(this.s.formDropdown&&!formDropdownWrap){
    this.s.formDropdown='';
    this.refreshRoute();
   }
   return;
  }
  const a=b.dataset.action;
  if(this.longTriggered){
   this.longTriggered=false;
   if(['device-open','habit-open','open-room'].includes(a))return;
  }
  if(a==='stop'||a==='noop'){e.stopPropagation();return}
  if(a==='focus-app'){this.shadowRoot.querySelector('[data-phone]').focus();return}
  if(a==='reset'){this.reset();return}
  if(a==='tab'){
   this.s.tab=b.dataset.tab;this.overlay=null;this.syncOverlay();this.renderBase();return;
  }
  if(a==='home-menu'){this.showOverlay({kind:'home-menu'});return}
  if(a==='plus-menu'){this.showOverlay({kind:'plus-menu'});return}
  if(a==='official-app-toast'){
   this.toast(this.copy.ui.toasts.officialApp);
   return;
  }
  if(a==='overlay-close'){this.closeOverlay();return}
  if(a==='dialog-cancel'){this.overlay=null;this.syncOverlay();return}
  if(a==='dialog-confirm'){
   const o=this.overlay;
   const value=o?.input?this.field('dialog-input',this.shadowRoot.querySelector('[data-overlay]')):undefined;
   this.overlay=null;this.syncOverlay();
   if(typeof o?.onConfirm==='function')o.onConfirm(value);
   return;
  }
  if(a==='overlay-route'){const route=b.dataset.route;this.overlay=null;this.syncOverlay();this.push(route);return}
  if(a==='overlay-info'){this.info(b.dataset.title,b.dataset.text);return}
  if(a==='overlay-habit-create'){this.overlay=null;this.syncOverlay();this.startHabit();return}
  if(a==='habit-create-open'){this.startHabit();return}
  if(a==='route'){this.push(b.dataset.route);return}
  if(a==='back'){this.pop();return}
  if(a==='summary'){this.toast(this.copy.ui.toasts.officialApp);return}
  if(a==='form-dropdown-toggle'){
   this.s.formDropdown=this.s.formDropdown===b.dataset.field?'':b.dataset.field;
   this.refreshRoute();
   return;
  }
  if(a==='form-dropdown-select'){
   const field=b.dataset.field,value=b.dataset.value;
   this.s.formValues[field]=value;
   this.s.formDropdown='';
   this.refreshRoute();
   return;
  }
  if(a==='accessory-filter'){this.s.accessoryFilter=b.dataset.value;this.refreshBase();return}
  if(a==='accessory-dropdown-toggle'){
   this.s.accessoryDropdown=this.s.accessoryDropdown===b.dataset.value?'':b.dataset.value;
   this.refreshBase();
   return;
  }
  if(a==='accessory-dropdown-select'){
   if(b.dataset.kind==='room')this.s.accessoryRoom=b.dataset.value;
   if(b.dataset.kind==='type')this.s.accessoryType=b.dataset.value;
   this.s.accessoryDropdown='';
   this.refreshBase();
   return;
  }
  if(a==='consumption-dropdown-toggle'){
   this.s.consumptionDropdown=this.s.consumptionDropdown===b.dataset.value?'':b.dataset.value;
   this.refreshBase();
   return;
  }
  if(a==='consumption-dropdown-select'){
   this.s.category=b.dataset.value;
   this.s.consumptionDropdown='';
   this.refreshBase();
   return;
  }
  if(a==='accessory-search'){return}
  if(a==='dashboard-edit'){this.toast(this.copy.ui.toasts.officialApp);return}
  if(a==='dashboard-remove'){
   this.s.dashboard=this.s.dashboard.filter(x=>x.id!==b.dataset.id);this.refreshRoute();return;
  }
  if(a==='dashboard-done'){this.closeAllRoutes();this.refreshBase();return}
  if(a==='dashboard-category'){
   this.s.selectedDashboardItems=[];
   this.push('dashboard-items',{category:b.dataset.value});return;
  }
  if(a==='dashboard-item-toggle'){
   const key=b.dataset.key,i=this.s.selectedDashboardItems.indexOf(key);
   if(i>=0)this.s.selectedDashboardItems.splice(i,1);else this.s.selectedDashboardItems.push(key);
   this.refreshRoute();return;
  }
  if(a==='dashboard-add-confirm'){
   this.s.selectedDashboardItems.forEach(key=>{
    const[kind,id]=key.split(':');
    if(!this.s.dashboard.some(x=>x.kind===kind&&x.ref===id))this.s.dashboard.push({id:uid('dash'),kind,ref:id});
   });
   this.s.selectedDashboardItems=[];
   this.refreshBase();
   if(this.routes.some(r=>r.route==='dashboard-edit')){
    this.popTo('dashboard-edit');
    setTimeout(()=>this.refreshRoute(),310);
   }else{
    this.closeAllRoutes();
    this.refreshBase();
   }
   this.toast(this.copy.ui.toasts.itemsAdded);
   return;
  }
  if(a==='device-open'){this.showOverlay({kind:'device',id:b.dataset.id});return}
  if(a==='device-toggle'){
   e.stopPropagation();
   const d=this.device(b.dataset.id);if(!d||!['light','outlet','switch'].includes(d.type))return;
   d.on=!d.on;
   this.updateDeviceVisual(d.id);
   this.updateDeviceSheetVisual(d.id);
   this.updateSummaryChips();
   this.toast(`${d.name}: ${d.on?this.copy.ui.states.on.toLowerCase():this.copy.ui.states.off.toLowerCase()}`);
   return;
  }
  if(a==='shutter'){e.stopPropagation();this.moveShutter(b.dataset.id,Number(b.dataset.value));return}
  if(a==='shutter-stop'){e.stopPropagation();clearInterval(this.shutterTimer);const d=this.device(b.dataset.id);if(d)d.moving=false;this.updateDeviceVisual(b.dataset.id);this.updateDeviceSheetVisual(b.dataset.id);return}
  if(a==='device-consumption'){
   e.stopPropagation();
   this.toast(this.copy.ui.toasts.officialApp);
   return;
  }
  if(a==='device-settings'){
   e.stopPropagation();
   this.toast(this.copy.ui.toasts.officialApp);
   return;
  }
  if(a==='device-menu-route'){
   const route=b.dataset.route,id=b.dataset.id;this.overlay=null;this.syncOverlay();this.push(route,{id});return;
  }
  if(a==='room-device-open'){this.showOverlay({kind:'device',id:b.dataset.id});return}
  if(a==='open-room'){this.showOverlay({kind:'room',id:b.dataset.id});return}
  if(a==='habit-create'){this.startHabit();return}
  if(a==='habit-open'){this.showOverlay({kind:'habit',id:b.dataset.id});return}
  if(a==='habit-run'){e.stopPropagation();this.runHabit(b.dataset.id);return}
  if(a==='habit-menu-open'){
   this.toast(this.copy.ui.toasts.officialApp);
   return;
  }
  if(a==='habit-enable-toggle')return;
  if(a==='habit-rename-dialog')return;
  if(a==='habit-delete-dialog')return;
  if(a==='habit-name-next'){
   if(this.s.draftHabit.name.trim())this.push('habit-builder');return;
  }
  if(a==='habit-options'){this.push('habit-options',{target:b.dataset.target});return}
  if(a==='habit-config-open'){this.s.formValues={};this.s.formDropdown='';this.push('habit-config',{target:b.dataset.target,kind:b.dataset.kind,title:b.dataset.title});return}
  if(a==='habit-component-remove'){
   this.s.draftHabit[b.dataset.target].splice(Number(b.dataset.index),1);this.refreshRoute();return;
  }
  if(a==='habit-config-confirm'){this.confirmHabitComponent(b.dataset.target,b.dataset.kind);return}
  if(a==='habit-save'){this.saveHabit();return}
  if(a==='period'){this.s.period=b.dataset.value;this.s.dateOffset=0;this.refreshBase();return}
  if(a==='category'){this.s.category=b.dataset.value;this.refreshBase();return}
  if(a==='date-prev'){this.s.dateOffset--;this.refreshBase();return}
  if(a==='date-next'){if(this.s.dateOffset<0)this.s.dateOffset++;else this.toast(this.copy.ui.toasts.currentPeriod);this.refreshBase();return}
  if(a==='consumption-info'){
   const copy={it:{title:'Consumo Istantaneo Totale',text:'Somma della potenza istantanea degli accessori attivi nella casa.'},en:{title:'Total instant consumption',text:'Sum of the instant power of active accessories in the home.'},es:{title:'Consumo instantáneo total',text:'Suma de la potencia instantánea de los accesorios activos de la casa.'},de:{title:'Gesamter Sofortverbrauch',text:'Summe der momentanen Leistung der aktiven Geräte im Zuhause.'},fr:{title:'Consommation instantanée totale',text:'Somme de la puissance instantanée des accessoires actifs dans la maison.'}};
   const entry=copy[this.locale]||copy.it;
   this.info(entry.title,entry.text);return;
  }
  if(a==='dialog-info'){this.info(b.dataset.title,b.dataset.text);return}
  if(a==='dialog-rename-home'){
   const labels=this.localizedLabels();
   this.confirm(labels.renameHome,labels.enterNewHomeName,value=>{if(value?.trim()){this.s.home.name=value.trim();this.refreshBase();this.refreshRoute();this.toast(this.copy.ui.toasts.homeRenamed)}},{input:true,label:labels.homeName,value:this.s.home.name,confirmLabel:this.copy.ui.common.save});return;
  }
  if(a==='dialog-delete-home'){const labels=this.localizedLabels();this.confirm(labels.deleteHome,labels.demoNoDelete,()=>this.toast(this.copy.ui.toasts.simulatedAction),{confirmLabel:this.copy.ui.common.delete});return}
  if(a==='room-open'){const room=this.s.rooms.find(r=>r.id===b.dataset.id);this.push('room-detail',{id:room.id,name:room.name});return}
  if(a==='room-preset'){
   const input=this.currentRoute().page.querySelector('[data-field="room-name"]');input.value=b.dataset.value;this.updateRoomSaveButton();return;
  }
  if(a==='room-save'){this.saveRoom();return}
  if(a==='room-update'){this.updateRoom(b.dataset.id);return}
  if(a==='room-delete'){this.deleteRoom(b.dataset.id);return}
  if(a==='copy-invite'){navigator.clipboard?.writeText(b.dataset.value).catch(()=>{});this.toast(this.copy.ui.toasts.copiedLink);return}
  if(a==='module-open'){const m=this.s.modules.find(x=>x.id===b.dataset.id);this.push('module-detail',{id:m.id,name:m.name});return}
  if(a==='module-save'){
   const m=this.s.modules.find(x=>x.id===b.dataset.id),v=this.field('module-name').trim();if(v)m.name=v;this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.moduleRenamed);return;
  }
  if(a==='module-remove'){
   const id=b.dataset.id,m=this.s.modules.find(x=>x.id===id);
   const labels=this.localizedLabels();
   const prompts={it:'Vuoi rimuovere',en:'Do you want to remove',es:'¿Quieres eliminar',de:'Möchtest du entfernen',fr:'Voulez-vous supprimer'};
   this.confirm(labels.removeModule,`${prompts[this.locale]||prompts.it} “${m.name}”?`,()=>{this.s.modules=this.s.modules.filter(x=>x.id!==id);this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.moduleRemoved)},{confirmLabel:this.copy.ui.common.delete});return;
  }
  if(a==='pair-modules'){this.push('pair-start');return}
  if(a==='pair-new'){this.push('pair-qr');return}
  if(a==='pair-scan'){this.push('pair-system');return}
  if(a==='pair-system-finish'){this.push('pair-found');return}
  if(a==='pair-found-next'){this.push('pair-name');return}
  if(a==='pair-name-next'){
   const v=this.field('pair-name').trim();if(v)this.s.pairing.name=v;this.push('pair-room');return;
  }
  if(a==='pair-room-select'){this.s.pairing.room=b.dataset.value;this.refreshRoute();return}
  if(a==='pair-room-next'){this.push('pair-input');return}
  if(a==='pair-input-select'){this.s.pairing.input=b.dataset.value;this.refreshRoute();return}
  if(a==='pair-input-next'){this.push('pair-done');return}
  if(a==='pair-go-accessories'){this.finishPairing();return}
  if(a==='rename-accessory-open'){this.push('rename-accessory',{id:b.dataset.id});return}
  if(a==='rename-accessory-save'){
   const d=this.device(b.dataset.id),v=this.field('rename-accessory').trim();if(v)d.name=v;this.refreshBase();this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.accessoryRenamed);return;
  }
  if(a==='schedule-open'){this.push('schedule-list',{id:b.dataset.id});return}
  if(a==='schedule-create-open'){this.push('schedule-create',{id:b.dataset.id});return}
  if(a==='schedule-save'){this.saveSchedule(b.dataset.id);return}
  if(a==='schedule-delete'){
   const list=this.s.schedules[b.dataset.id]||[];list.splice(Number(b.dataset.index),1);this.refreshRoute();this.toast(this.copy.ui.toasts.scheduleDeleted);return;
  }
  if(a==='sun-open'){this.push('sun-list',{id:b.dataset.id});return}
  if(a==='sun-create-open'){this.push('sun-create',{id:b.dataset.id});return}
  if(a==='sun-save'){this.saveSun(b.dataset.id);return}
  if(a==='sun-delete'){
   const list=this.s.sunRules[b.dataset.id]||[];list.splice(Number(b.dataset.index),1);this.refreshRoute();this.toast(this.copy.ui.toasts.sunRuleDeleted);return;
  }
  if(a==='overlay-device-menu'){this.showOverlay({kind:'device-menu',id:b.dataset.id});return}
 }
 input(e){
  const f=e.target.dataset.field;
 if(f==='habit-name'){
  this.s.draftHabit.name=e.target.value;
  const btn=this.currentRoute()?.page.querySelector('[data-action="habit-name-next"]');
  if(btn){const ok=Boolean(e.target.value.trim());btn.disabled=!ok;btn.classList.toggle('enabled',ok)}
 }
 if(f==='accessory-search'){
  this.s.accessoryQuery=e.target.value;
  this.refreshBase();
 }
  if(f==='cfg-device')this.refreshRoute();
  if(f==='room-name')this.updateRoomSaveButton();
 }
 pointerDown(e){
  const track=e.target.closest('[data-role="shutter-track"]');
  if(track){
   e.preventDefault();
   this.draggingShutter={id:track.dataset.id,track};
   this.dragPointerId=e.pointerId;
   track.setPointerCapture?.(e.pointerId);
   this.updateShutterFromPointer(track,e.clientY);
   return;
  }
  const target=e.target.closest('[data-longpress]');
  if(!target)return;
  this.longTriggered=false;
  clearTimeout(this.longTimer);
  this.longTimer=setTimeout(()=>{
   this.longTriggered=true;
   const kind=target.dataset.longpress,id=target.dataset.id;
   if(kind==='device')return;
   if(kind==='habit')return;
   if(kind==='room')this.showOverlay({kind:'room',id});
  },520);
 }
 pointerMove(e){
  if(!this.draggingShutter)return;
  if(e.pointerId!==this.dragPointerId)return;
  e.preventDefault();
  this.updateShutterFromPointer(this.draggingShutter.track,e.clientY);
 }
 pointerUp(e){
  clearTimeout(this.longTimer);
  if(this.draggingShutter){
   if(e.pointerId!==this.dragPointerId)return;
   this.draggingShutter.track.releasePointerCapture?.(this.dragPointerId ?? e.pointerId);
   const id=this.draggingShutter.id;
   this.draggingShutter=null;
   this.dragPointerId=null;
   this.refreshBase();
   this.toast(`${this.device(id).name}: ${Math.round(this.device(id).position)}%`);
  }
 }

 reset(){
  clearInterval(this.shutterTimer);
  this.s=buildDemoState(this.locale);
  this.overlay=null;
  this.closeAllRoutes();
  this.syncOverlay();
  this.renderBase();
  this.toast(this.copy.ui.toasts.demoReset);
 }
 startHabit(){
  this.s.draftHabit={name:'',when:[],onlyIf:[],actions:[]};
  this.push('habit-builder');
 }
 confirmHabitComponent(target,kind){
  const labels=this.localizedLabels();
  const root=this.currentRoute().page;
  const days=this.selectedDays(root);
  let item={icon:'info',title:labels.item,detail:this.copy.ui.common.configure,kind};
  if(kind==='trigger-schedule'){
   const time=this.field('cfg-time',root)||'08:00';
   item={icon:'clock',title:this.copy.ui.common.schedule,detail:`${time}, ${days.join(', ')}`,kind,time,days};
  }else if(kind==='trigger-sun'){
   const event=this.selectedChoice('cfg-event',root)||labels.sunrise;
   const offset=this.field('cfg-offset',root)||'0';
   const before=this.selectedChoice('cfg-before',root)||labels.before;
   item={icon:'sunset',title:this.copy.ui.common.sunriseSunset,detail:`${event} • ${offset}m ${before.toLowerCase()}, ${days.join(', ')}`,kind,event,offset,before,days};
  }else if(kind==='trigger-daynight'||kind==='query-daynight'){
   const event=this.selectedChoice('cfg-event',root)||labels.night;
   item={icon:'moon',title:this.habitCatalog('when').find(x=>x.kind==='trigger-daynight')?.title||this.copy.ui.routeTitles.when,detail:`${event}, ${days.join(', ')}`,kind,event,days};
  }else if(kind.includes('consumption')){
   const deviceId=this.field('cfg-device',root),d=this.device(deviceId);
   const comparison=this.selectedChoice('cfg-comparison',root)||labels.lessThan;
   const threshold=this.field('cfg-threshold',root)||'500';
   item={icon:'battery',title:this.habitCatalog(kind==='query-consumption'?'onlyIf':'when').find(x=>x.kind===kind)?.title||'',detail:`${d.name} • ${comparison} ${threshold}W`,kind,deviceId,comparison,threshold};
  }else if(kind==='action-shutter'){
   const deviceId=this.field('cfg-device',root),d=this.device(deviceId);
   const state=this.selectedChoice('cfg-state',root)||labels.open;
   item={icon:'shutter',title:this.copy.ui.accessories.types.shutter,detail:`${d.name} • ${state}`,kind,deviceId,position:state===labels.open?100:0};
  }else if(kind.includes('accessory')){
   const deviceId=this.field('cfg-device',root),d=this.device(deviceId);
   const state=this.selectedChoice('cfg-state',root)||(kind==='action-accessory'?labels.turnOn:labels.stateChanged);
   item={icon:'puzzle',title:this.copy.ui.common.accessory,detail:`${d.name} • ${state}`,kind,deviceId,state,nextOn:kind==='action-accessory'?this.isTruthyActionState(state):undefined};
  }else if(kind.includes('module')){
   const moduleId=this.field('cfg-module',root),m=this.s.modules.find(x=>x.id===moduleId);
   const state=this.selectedChoice('cfg-state',root)||labels.stateChanged;
   item={icon:'module',title:this.copy.ui.common.module,detail:`${m.model} • ${state}`,kind,moduleId,state};
  }else if(kind==='query-time'){
   const from=this.field('cfg-from',root),to=this.field('cfg-to',root);
   item={icon:'clock',title:this.habitCatalog('onlyIf').find(x=>x.kind==='query-time')?.title||'',detail:`${labels.between} ${from} ${labels.and} ${to}, ${days.join(', ')}`,kind,from,to,days};
  }else if(kind==='action-notification'){
   const title=this.field('cfg-title',root),message=this.field('cfg-message',root);
   item={icon:'notification',title:this.habitCatalog('actions').find(x=>x.kind==='action-notification')?.title||'',detail:title,kind,notificationTitle:title,message};
  }else if(kind==='action-wait'){
   const hours=this.field('cfg-hours',root)||'0',minutes=this.field('cfg-minutes',root)||'0';
   item={icon:'wait',title:this.habitCatalog('actions').find(x=>x.kind==='action-wait')?.title||'',detail:`${hours}h ${minutes}m`,kind,hours,minutes};
  }else if(kind==='action-habit'){
   const habitId=this.field('cfg-habit',root),state=this.selectedChoice('cfg-state',root)||labels.start;
   const h=this.s.habits.find(x=>x.id===habitId);
   item={icon:'habits',title:this.copy.ui.nav.habits,detail:`${state} ${h?.name||(DEMO_SEED_COPY[this.locale]||DEMO_SEED_COPY.it).habits.habitNight.name}`,kind,habitId,state};
  }else if(kind==='trigger-nfc'){
   item={icon:'nfc',title:this.habitCatalog('when').find(x=>x.kind==='trigger-nfc')?.title||'NFC',detail:this.habitCatalog('when').find(x=>x.kind==='trigger-nfc')?.detail||labels.simulateScan,kind};
  }
  this.s.draftHabit[target].push(item);
  this.popTo('habit-builder');
  setTimeout(()=>this.refreshRoute(),310);
 }
 saveHabit(){
  const d=this.s.draftHabit;
  if(!d.name.trim()||!d.when.length||!d.actions.length)return;
  const h={id:uid('habit'),name:d.name.trim(),when:clone(d.when),onlyIf:clone(d.onlyIf),actions:clone(d.actions),active:false,disabled:false,summary:this.habitCountSummary(d.when.length,d.actions.length)};
  this.s.habits.push(h);
  this.closeAllRoutes();
  this.s.tab='habits';
  this.renderBase();
  this.toast(this.copy.ui.toasts.habitSaved);
 }
 runHabit(id){
  const h=this.s.habits.find(x=>x.id===id);
  if(!h||h.disabled){this.toast(this.copy.ui.toasts.habitDisabled);return}
  h.active=true;
  h.actions.forEach(a=>{
   if(a.kind==='action-accessory'){
    const d=this.device(a.deviceId);
    if(d&&['light','outlet','switch'].includes(d.type))d.on=typeof a.nextOn==='boolean'?a.nextOn:this.isTruthyActionState(a.state);
   }
   if(a.kind==='action-shutter'){
    const d=this.device(a.deviceId);
    if(d&&d.type==='shutter'){d.position=a.position;this.updateShutterVisual(d.id);}
   }
  });
  this.updateSummaryChips();
  h.actions.forEach(a=>{
   if(a.kind==='action-accessory')this.updateDeviceVisual(a.deviceId);
   if(a.kind==='action-shutter')this.updateDeviceVisual(a.deviceId);
  });
  if(this.overlay?.kind==='habit'&&this.overlay.id===id)this.updateHabitSheetVisual(id);
  this.toast(`${h.name}: ${this.copy.ui.toasts.habitExecuted}`);
  setTimeout(()=>{
   h.active=false;
   this.updateSummaryChips();
   h.actions.forEach(a=>{
    if(a.kind==='action-accessory')this.updateDeviceVisual(a.deviceId);
    if(a.kind==='action-shutter')this.updateDeviceVisual(a.deviceId);
   });
   if(this.overlay?.kind==='habit'&&this.overlay.id===id)this.updateHabitSheetVisual(id);
  },900);
 }
 updateHabitSheetVisual(id){
  const h=this.s.habits.find(x=>x.id===id);
  if(!h)return;
  const active=h.active;
  this.shadowRoot.querySelectorAll(`[data-habit-id="${id}"] .fp-entity-icon.habit`).forEach(icon=>icon.classList.toggle('on',active));
  const overlay=this.shadowRoot.querySelector('[data-overlay]');
  const sheet=overlay?.querySelector('.fp-sheet');
  if(!sheet)return;
  const icon=sheet.querySelector('.fp-sheet-header .fp-entity-icon.habit');
  const button=sheet.querySelector(`[data-action="habit-run"][data-id="${id}"]`);
  const label=sheet.querySelector('.fp-light-state');
  if(icon)icon.classList.toggle('on',active);
  if(button){
   button.classList.toggle('off',!active);
   button.style.background=active?'var(--fp-blue)':'';
   button.innerHTML=I(active?'pause':'play');
  }
 if(label)label.textContent=active?this.localizedLabels().running:this.localizedLabels().ready;
 }
 moveShutter(id,target){
  clearInterval(this.shutterTimer);
  const d=this.device(id);if(!d)return;
  d.moving=true;
  const direction=target>d.position?1:-1;
  this.shutterTimer=setInterval(()=>{
   d.position=Math.max(0,Math.min(100,d.position+direction*3));
   this.updateShutterVisual(id);
   if((direction>0&&d.position>=target)||(direction<0&&d.position<=target)){
    d.position=target;
    d.moving=false;
    clearInterval(this.shutterTimer);
    this.updateShutterVisual(id);
    this.updateSummaryChips();
    this.toast(`${d.name}: ${target}%`);
   }
  },45);
 }
 updateShutterFromPointer(track,clientY){
  const rect=track.getBoundingClientRect();
  const relative=Math.max(0,Math.min(1,(clientY-rect.top)/rect.height));
  const position=Math.round((1-relative)*100);
  const d=this.device(track.dataset.id);
  d.position=position;
  d.moving=false;
  this.updateShutterVisual(d.id,track);
 }
 updateShutterVisual(id,stableTrack){
  const d=this.device(id);if(!d)return;
  const visual=100-Math.max(0,Math.min(100,d.position));
  const overlay=this.shadowRoot.querySelector('[data-overlay]');
  const track=stableTrack||overlay.querySelector(`[data-role="shutter-track"][data-id="${id}"]`);
  if(track){
   track.setAttribute('aria-valuenow',String(Math.round(d.position)));
   const fill=track.querySelector('.fp-vertical-fill');
   const line=track.querySelector('.fp-vertical-line');
   if(fill)fill.style.height=`${visual}%`;
   if(line)line.style.top=`${visual}%`;
   const bubble=track.parentElement?.querySelector('.fp-percent-bubble');
   if(bubble){bubble.style.top=`${visual}%`;bubble.textContent=`${Math.round(d.position)}%`;}
  }
  this.shadowRoot.querySelectorAll(`[data-device-id="${id}"]`).forEach(tile=>{
   const percent=tile.querySelector('.fp-percent');
   if(percent)percent.textContent=`${Math.round(d.position)}%`;
   const avatar=tile.querySelector('.fp-entity-icon.shutter');
   if(avatar)avatar.classList.toggle('on',d.position>0);
  });
  this.updateSummaryChips();
 }
 updateSummaryChips(){
  const summary=this.summary();
  this.shadowRoot.querySelectorAll('[data-summary-kind]').forEach(chip=>{
   const label=chip.querySelector('[data-summary-label]');
   if(!label)return;
   if(chip.dataset.summaryKind==='light'){
    label.textContent=this.summaryText('light',summary.lights);
    chip.classList.toggle('is-active',summary.lights>0);
   }
   if(chip.dataset.summaryKind==='shutter'){
    label.textContent=this.summaryText('shutter',summary.shutters);
    chip.classList.toggle('is-active',summary.shutters>0);
   }
   if(chip.dataset.summaryKind==='outlet'){
    label.textContent=this.summaryText('outlet',summary.outlets);
    chip.classList.toggle('is-active',summary.outlets>0);
   }
  });
 }
 updateDeviceVisual(id){
  const d=this.device(id);if(!d)return;
  const active=d.type==='shutter'?d.position>0:d.on;
 this.shadowRoot.querySelectorAll(`[data-device-id="${id}"]`).forEach(node=>{
   const icon=node.querySelector('.fp-entity-icon');
   if(icon)icon.classList.toggle('on',active);
   if(node.classList.contains('outlet-tv')){
    node.classList.toggle('on',active);
    node.classList.toggle('off',!active);
    const toggle=node.querySelector('.fp-tv-toggle');
    if(toggle){
     toggle.classList.toggle('on',active);
     toggle.classList.toggle('off',!active);
     toggle.setAttribute('aria-pressed',String(active));
    }
   }
   const watt=node.querySelector('.fp-watt');
   if(watt && ['light','outlet'].includes(d.type))watt.hidden=!d.on;
  });
 }
 updateDeviceSheetVisual(id){
  const d=this.device(id);if(!d)return;
  const overlay=this.shadowRoot.querySelector('[data-overlay]');
  const sheet=overlay?.querySelector('.fp-sheet');
  if(!sheet)return;
  const icon=sheet.querySelector(`[data-device-sheet-icon="${id}"]`);
  if(icon)icon.classList.toggle('on',d.type==='shutter'?d.position>0:d.on);
  if(d.type==='light'||d.type==='outlet'||d.type==='switch'){
   const toggle=sheet.querySelector(`[data-device-toggle="${id}"]`);
   const state=sheet.querySelector(`[data-device-state="${id}"]`);
   if(toggle)toggle.classList.toggle('off',!d.on);
   if(state)state.textContent=d.on?this.copy.ui.states.on:this.copy.ui.states.off;
  }
 }
 updateRoomSaveButton(){
  const r=this.currentRoute();if(!r)return;
  const input=r.page.querySelector('[data-field="room-name"]'),btn=r.page.querySelector('[data-action="room-save"]');
  if(btn){const ok=Boolean(input?.value.trim());btn.disabled=!ok;btn.classList.toggle('enabled',ok)}
 }
 saveRoom(){
  const name=this.field('room-name').trim();if(!name)return;
  this.s.rooms.push({id:uid('room'),name,icon:'room'});
  this.pop();
  setTimeout(()=>this.refreshRoute(),310);
  this.toast(this.copy.ui.toasts.roomAdded);
 }
 updateRoom(id){
  const room=this.s.rooms.find(r=>r.id===id),old=room.name,name=this.field('room-edit-name').trim();
  if(name){room.name=name;Object.values(this.s.devices).forEach(d=>{if(d.room===old)d.room=name})}
  this.pop();setTimeout(()=>this.refreshRoute(),310);this.refreshBase();this.toast(this.copy.ui.toasts.roomUpdated);
 }
 deleteRoom(id){
  const room=this.s.rooms.find(r=>r.id===id);
  if(Object.values(this.s.devices).some(d=>d.room===room.name)){this.info(this.copy.ui.toasts.impossibleDeleteRoom,this.copy.ui.toasts.moveAccessoriesFirst);return}
  const labels=this.localizedLabels();
  this.confirm(labels.deleteRoomTitle,`${labels.deleteRoomText} “${room.name}”?`,()=>{this.s.rooms=this.s.rooms.filter(r=>r.id!==id);this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.roomDeleted)},{confirmLabel:this.copy.ui.common.delete});
 }
 finishPairing(){
  const id=uid('accessory'),moduleId=uid('module');
  this.s.devices[id]={id,name:this.s.pairing.name,room:this.s.pairing.room,type:'light',on:false,watt:6,energy:0,module:'LB0801-E',input:this.s.pairing.input};
  this.s.modules.push({id:moduleId,name:`${(DEMO_SEED_COPY[this.locale]||DEMO_SEED_COPY.it).modulePrefix} ${this.s.pairing.name}`,model:'LB0801-E',serial:String(Math.floor(70000000+Math.random()*999999))});
  this.closeAllRoutes();
  this.s.tab='accessories';this.s.accessoryFilter='all';this.renderBase();this.toast(this.copy.ui.toasts.accessoryAdded);
 }
 saveSchedule(id){
  const root=this.currentRoute().page,time=this.field('schedule-time',root),action=this.field('schedule-action',root),days=this.selectedDays(root);
  if(!this.s.schedules[id])this.s.schedules[id]=[];
  this.s.schedules[id].push({time,action,days:days.length===7?this.localizedLabels().allDays:days.join(', ')});
  this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.scheduleSaved);
 }
 saveSun(id){
  const labels=this.localizedLabels();
  const root=this.currentRoute().page,event=this.selectedChoice('sun-event',root)||labels.sunset,action=this.selectedChoice('sun-action',root)||this.copy.ui.states.on,offset=this.field('sun-offset',root)||'0';
  if(!this.s.sunRules[id])this.s.sunRules[id]=[];
  this.s.sunRules[id].push({event,action,offset:`${offset} ${labels.minutesSuffix}`});
  this.pop();setTimeout(()=>this.refreshRoute(),310);this.toast(this.copy.ui.toasts.sunRuleSaved);
 }
 toast(message){
  const t=this.shadowRoot.querySelector('[data-toast]');
  t.textContent=message;t.classList.add('show');
  clearTimeout(this.toastTimer);
  this.toastTimer=setTimeout(()=>t.classList.remove('show'),2200);
 }
}
if(!customElements.get('freedompro-maestro-demo'))customElements.define('freedompro-maestro-demo',FreedomproMaestroDemo);
})();
